(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9328],{

/***/ 24738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_BundlePdpPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/ImageGallery/v2/constants.js
var v2_constants = __webpack_require__(75671);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/utils/index.js
const findCommonItemsReduceFilter = (arrayOfArrays)=>{
    if (arrayOfArrays.length === 0) {
        return [];
    }
    const commonItems = arrayOfArrays.slice(1).reduce((accumulator, currentArray)=>{
        const currentNames = new Set(currentArray.map((item)=>item.name));
        return accumulator.filter((item)=>currentNames.has(item.name));
    }, arrayOfArrays[0]);
    return commonItems.map((item)=>({
            name: item.name,
            swatch: item.swatch
        }));
};
const getCommonColorDetails = (data)=>{
    const { bundleItems =[] , selectedMasterSkus =[]  } = data || {};
    const initSelectedMasterSkus = bundleItems.map(function() {
        let item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const { products =[]  } = item;
        const { masterSku =""  } = products.at(0) || {};
        return masterSku;
    });
    const selectedSkus = selectedMasterSkus.length ? selectedMasterSkus : initSelectedMasterSkus || [];
    const variantColorList = [];
    selectedSkus.forEach((sku)=>{
        bundleItems.forEach((item)=>{
            const { colorDetails  } = item.products.find((product)=>product.masterSku === sku) || {};
            colorDetails && variantColorList.push(colorDetails);
        });
    });
    return findCommonItemsReduceFilter(variantColorList);
};
const getSelectedProductPrices = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { productLists =[] , skus =[] , currencyCode ="" , persona =""  } = data;
    return skus.map((sku)=>{
        var ref, ref1, ref2;
        const item = productLists.find((p)=>p.masterVariant.sku === sku || p.variants.find((v)=>v.sku === sku)) || {};
        const { masterVariant: { sku: masterSku = "" , prices =""  } = {} , variants =[]  } = item;
        let responseProduct = [];
        if (masterSku && masterSku === sku) {
            responseProduct = prices;
        } else {
            var ref3, ref4;
            responseProduct = (ref3 = variants.filter((variant)=>variant.sku === sku)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.prices;
        }
        const fixedPromo = responseProduct === null || responseProduct === void 0 ? void 0 : responseProduct.find((price)=>{
            var ref, ref1, ref2, ref3, ref4;
            return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona && ((ref3 = price.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.fixedPrice);
        });
        const productPrice = responseProduct === null || responseProduct === void 0 ? void 0 : responseProduct.find((price)=>{
            var ref, ref1, ref2;
            return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && ((ref1 = price.customerGroup) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : ref2.key) === persona;
        });
        let priceObj = fixedPromo || productPrice;
        if (!(priceObj === null || priceObj === void 0 ? void 0 : priceObj.value)) {
            priceObj = responseProduct === null || responseProduct === void 0 ? void 0 : responseProduct.find((price)=>{
                var ref;
                return ((ref = price.value) === null || ref === void 0 ? void 0 : ref.currencyCode) === currencyCode && !price.customerGroup;
            });
        }
        var ref5;
        const priceProduct = Number((((ref5 = priceObj === null || priceObj === void 0 ? void 0 : (ref = priceObj.value) === null || ref === void 0 ? void 0 : ref.centAmount) !== null && ref5 !== void 0 ? ref5 : 0) / 100).toFixed(2)) || 0;
        var ref6;
        const discountPrice = Number(((ref6 = priceObj === null || priceObj === void 0 ? void 0 : (ref1 = priceObj.discounted) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.centAmount) !== null && ref6 !== void 0 ? ref6 : 0) / 100).toFixed(2) || 0;
        return {
            sku,
            priceProduct,
            discountPrice
        };
    });
};
const getSelectedImageGallaryDetails = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, selectedSkus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const imageDetailsInfo = [];
    selectedSkus.forEach((sku)=>{
        var ref;
        (ref = Object.entries(data)) === null || ref === void 0 ? void 0 : ref.map((param)=>{
            let [key, value] = param;
            const colorInfo = value.filter((item)=>{
                const productSkuKey = sku === null || sku === void 0 ? void 0 : sku.split("-").slice(0, -1).join("-");
                return item.sku.includes(productSkuKey) || item.masterSKU.includes(productSkuKey);
            });
            if (colorInfo.length === 0) return null;
            imageDetailsInfo.push(Object(colorInfo[0]));
        });
    });
    return imageDetailsInfo;
};
const getImageGalleryData = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, selectedSkus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const imageDetailsInfo = [];
    let videoDeatilsInfo = [];
    if (data === null || data === void 0 ? void 0 : data.ProductImageURL) {
        data === null || data === void 0 ? void 0 : data.ProductImageURL.map((item)=>{
            const eachspliteditem = item === null || item === void 0 ? void 0 : item.split("|");
            if (eachspliteditem[0] === selectedSkus) {
                imageDetailsInfo.push({
                    label: eachspliteditem[4],
                    // remove the space from the string
                    assetId: eachspliteditem[1].replace(/\s+/g, ""),
                    url: eachspliteditem[5]
                });
            }
        });
        videoDeatilsInfo = data.ProductVideoID.split("|").map((item)=>{
            return {
                type: "video",
                url: item
            };
        });
    }
    const imageVideo = {
        imageDetailsInfo,
        videoDeatilsInfo
    } || {};
    return imageVideo === null || imageVideo === void 0 ? void 0 : imageVideo.imageDetailsInfo;
};
const getAllImage = function() {
    let selectedSkusDetails = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], selectedImageDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const intialimages = [];
    const restimage = [];
    const videos = [];
    selectedSkusDetails.forEach((item)=>{
        var ref;
        item === null || item === void 0 ? void 0 : (ref = item.ProductVideoID) === null || ref === void 0 ? void 0 : ref.split("|").forEach((video)=>{
            if (video) {
                videos.push({
                    type: "video",
                    url: video
                });
            }
        });
    });
    selectedImageDetails === null || selectedImageDetails === void 0 ? void 0 : selectedImageDetails.forEach((item)=>{
        if (item.length !== 0) {
            intialimages.push(item[0]);
            restimage.push(...item.splice(1));
        }
    });
    const allImages = [
        ...intialimages,
        // ...restimage, // Uncomment if you want to include rest images
        ...videos
    ];
    return {
        allImages,
        intialimages
    };
};
const getLayeredImage = function() {
    let intialimages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], bundleImageURL = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], selectedSkus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    let imageURL = bundleImageURL;
    if (intialimages.length === selectedSkus.length) {
        intialimages.forEach((item, index)=>{
            const imageindex = "<<IMAGE".concat(index + 1, ">>");
            imageURL = imageURL.replace(imageindex, item === null || item === void 0 ? void 0 : item.assetId);
        });
        return imageURL;
    } else {
        return "";
    }
};
const getSelectedProductData = (data)=>{
    const { bundleItems =[] , selectedProducts =[] , skusPrice =""  } = data || {};
    const priceMap = {};
    skusPrice === null || skusPrice === void 0 ? void 0 : skusPrice.forEach((item)=>{
        priceMap[item.sku] = Number(item.discountPrice) || Number(item.priceProduct) || 0;
    });
    const selectedSkus = selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.sku;
    });
    const productData = bundleItems.flatMap((item)=>item.products).map((product)=>{
        const { colorDetails =[] , imageDetails =[] , title =""  } = product || {};
        const { sku ="" , name =""  } = colorDetails.find((item)=>selectedSkus.includes(item.sku)) || {};
        if (!sku) return null;
        const unitPrice = priceMap[sku] || 0;
        const { imageUrl  } = imageDetails.find((item)=>item.sku === sku) || {};
        const imageUrlPath = "".concat(imageUrl, "?wid=80&hei=80&bgc=f9f9f9");
        return {
            productName: title || "",
            color: name || "",
            image: imageUrlPath,
            quantity: 1,
            unitPrice: unitPrice || 0,
            sku: sku || ""
        };
    }).filter(Boolean);
    return productData;
};
const isSkuBackOrderable = (param)=>{
    let { data =[] , sku =""  } = param;
    let isBackorderableValue = false;
    data === null || data === void 0 ? void 0 : data.forEach((each)=>{
        const allVariants = each === null || each === void 0 ? void 0 : each.variants.concat(each === null || each === void 0 ? void 0 : each.masterVariant);
        allVariants === null || allVariants === void 0 ? void 0 : allVariants.forEach((item)=>{
            if (item.sku === sku) {
                const { attributes  } = item;
                const isBackorderable = attributes === null || attributes === void 0 ? void 0 : attributes.find((attribute)=>attribute.name === "RegionIsBackorderable");
                isBackorderableValue = isBackorderable === null || isBackorderable === void 0 ? void 0 : isBackorderable.value;
            }
        });
    });
    return isBackorderableValue;
};
const getSelectedbundleDetails = (param)=>{
    let { data ={} , selectedSkus =[]  } = param;
    const productDetailsInfo = [];
    selectedSkus.forEach((sku)=>{
        data.map((each)=>{
            var ref;
            const productSkuKey = sku === null || sku === void 0 ? void 0 : sku.split("-").slice(0, -1).join("-");
            const selectedItemDetails = each === null || each === void 0 ? void 0 : (ref = each.products) === null || ref === void 0 ? void 0 : ref.filter((item)=>{
                const isMatched = (item === null || item === void 0 ? void 0 : item.sku.includes(productSkuKey)) || (item === null || item === void 0 ? void 0 : item.masterSku.includes(productSkuKey));
                return isMatched;
            });
            if (selectedItemDetails.length !== 0) productDetailsInfo.push(selectedItemDetails[0]);
        });
    });
    return productDetailsInfo;
};
const getAddToCartItems = function() {
    let selectedProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], bundleItems = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], projectionData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], quantity = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, bundleAnalyticsData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    const selectedProductsData = selectedProducts.map((selected)=>{
        const { products =[]  } = bundleItems.find((item)=>item.name === selected.name);
        const { productType =""  } = products.find((product)=>{
            return product.masterSku === selected.masterSku;
        });
        const isBackorderable = isSkuBackOrderable({
            data: projectionData,
            sku: selected.sku
        });
        return {
            sku: selected.sku,
            isComboSku: productType === "engineer-bundle",
            backorder: isBackorderable
        };
    });
    const items = selectedProductsData.map((selectedProduct)=>{
        const { isComboSku =false , sku ="" , backorder =false  } = selectedProduct;
        return {
            sku,
            quantity,
            isBundleProduct: false,
            isBundle: isComboSku,
            selectedBundlesProduct: bundleAnalyticsData || null,
            backorder
        };
    });
    return items;
};
const checkIsAllProductsAvailable = function() {
    let selectedProducts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], projectionData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.every((item)=>{
        const isBackorderable = isSkuBackOrderable({
            data: projectionData,
            sku: item.sku
        });
        return isBackorderable || item.isInventory;
    });
};
const getStickyHeaderProps = (state, staticTexts, availableColors, swatchName)=>{
    const { pdpDetails ={} , projectionData =[] , selectedProducts =[]  } = state;
    const { name: title = "" , desc: description = ""  } = pdpDetails;
    const color = availableColors.find((item)=>item.label === swatchName) || {};
    const isAllProductsAvailable = checkIsAllProductsAvailable(selectedProducts, projectionData);
    return {
        stickyHeaderProps: {
            title,
            description,
            color: {
                label: color.label || "",
                url: color.colorUrl || ""
            }
        },
        staticTexts: {
            addToCart: (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.addToCartLabel) || ""
        },
        disableBundleAddToCart: !isAllProductsAvailable,
        isRegionSoldOnline: true,
        isDiscontinued: false,
        disableEcommerce: false,
        handleScroll: ()=>{},
        onAvailableColor: ()=>{}
    };
};
const processImageData = (bundleListImages, selectedSkus, bundleIMageURL)=>{
    const selectedSkusDetails = getSelectedImageGallaryDetails(bundleListImages, selectedSkus);
    const selectedImageDetails = selectedSkus.map((sku, index)=>{
        return getImageGalleryData(selectedSkusDetails[index], sku);
    });
    const { allImages , intialimages  } = getAllImage(selectedSkusDetails, selectedImageDetails);
    const imageURL = getLayeredImage(intialimages, bundleIMageURL, selectedSkus);
    return {
        allImages,
        imageURL
    };
};

;// CONCATENATED MODULE: ./responseProcessors/productResponseProcessor.js
const getBundlePdpData = (data)=>{
    const { BundleDescription_s: name = "" , BundleID_s: sku = "" , BundleNarrativeDescription_s: desc = "" , ColorFinish_ss: colorFinish = [] , BundleList_ss: bundleList = [] , BundleComponent_ss: bundleComponents = [] , BundleLocalCategory_s: productLocalCategory = "" , BundleImageURL_s: bundleIMageURL = ""  } = data || {};
    return {
        pdpDetails: {
            sku,
            name,
            desc,
            productLocalCategory
        },
        colorDetails: getColorDetails(colorFinish),
        bundleItems: getBundleItemsData({
            bundleComponents,
            bundleList
        }),
        imageGallery: productResponseProcessor_getImageGalleryData({
            bundleList,
            bundleIMageURL
        })
    };
};
const getBundleItemsData = (data)=>{
    const { bundleComponents =[] , bundleList =[]  } = data || {};
    const productGroupList = [];
    Object.entries(bundleList).forEach((param, i)=>{
        let [key, value] = param;
        var ref;
        const products = [];
        value.forEach((item)=>{
            var ref;
            const { BundleSku_s: sku = "" , title_s: title = "" , ProductLocalCategory_s: category = "" , masterSKU_s: masterSku = "" , slug_s: slug = "" , ["productImages.labelWithUrl_ss"]: variantImages = [] , ["Color.Name.Details_ss"]: variantColorNames = [] , ["Color.SKU.Details_ss"]: colorVariant = [] , ProductWebFeatures_ss: productWebFeatures = [] , ProductBadgeInfo_ss: productBadgeInfo = [] , ProductDimensionAttributes: productDimensionAttributes = [] , ctProductType_s: productType = "" , ProductDimensionAttributesValues: productDimensionAttributesValues = [] , ["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]: specPDFFileName = [] , ["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]: installGuidesFiles = [] , caterogy1_s: primaryCategory = "" , ProductBrandNameDisplay_t: productBrandName = "" , productName_s: productName = "" , RegionBrandName_s: regionBrandName = "" , ProductWaterSense_ss: productWaterSense = false  } = item || {};
            const colorFinish = variantColorNames.map((color)=>{
                const [name = "", swatch = ""] = color.split("|");
                return {
                    name,
                    swatch
                };
            });
            const colorDetails = colorVariant.map((color)=>{
                const [name = "", swatch = "", sku, , , customerFacingSku = ""] = color.split("|");
                return {
                    sku,
                    name,
                    swatch,
                    customerFacingSku
                };
            });
            const imageDetails = variantImages.map((image)=>{
                const variant = image.split("|");
                return {
                    sku: variant.at(0),
                    id: variant.at(1),
                    imageUrl: variant.at(-1)
                };
            });
            const swatchName = ((ref = colorFinish.at(0)) === null || ref === void 0 ? void 0 : ref.name) || "";
            const { id: assetId = "" , imageUrl =""  } = getSelectedColorImage({
                colorDetails,
                imageDetails,
                swatchName
            });
            products.push({
                imageUrl,
                assetId,
                sku,
                masterSku,
                slug,
                category,
                title,
                imageDetails,
                colorFinish,
                colorDetails,
                productWebFeatures,
                productBadgeInfo,
                productDimensionAttributes,
                productType,
                productDimensionAttributesValues,
                specPDFFileName,
                installGuidesFiles,
                primaryCategory,
                productBrandName,
                productName,
                regionBrandName,
                productWaterSense
            });
        });
        const bundleName = ((ref = bundleComponents[i]) === null || ref === void 0 ? void 0 : ref.split("|").at(1)) || "";
        productGroupList.push({
            name: bundleName,
            products
        });
    });
    return productGroupList;
};
const getColorDetails = function() {
    let colorFinish = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return colorFinish.map(function() {
        let color = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        const [name = "", swatch = ""] = color.split("|");
        return {
            name,
            swatch
        };
    });
};
const productResponseProcessor_getImageGalleryData = (param)=>{
    let { bundleList =[] , bundleIMageURL =""  } = param;
    const bundleListImages = Object.entries(bundleList).map((param)=>{
        let [key, value] = param;
        return value.map((each)=>{
            return {
                ProductImageURL: each["productImages.labelWithUrl_ss"],
                ProductVideoID: (each === null || each === void 0 ? void 0 : each.ProductYoutubeID_s) || "",
                sku: each.sku_s,
                masterSKU: each.masterSKU_s
            };
        });
    });
    const imageData = {
        bundleIMageURL: bundleIMageURL || "",
        bundleListImages: bundleListImages
    };
    return imageData;
};
const getSelectedColorImage = (data)=>{
    var ref;
    const { colorDetails =[] , imageDetails =[] , swatchName =""  } = data;
    const { sku ="" , customerFacingSku =""  } = colorDetails.find((e)=>e.name === swatchName) || {};
    const colorSku = sku || ((ref = colorDetails.at(0)) === null || ref === void 0 ? void 0 : ref.sku) || "";
    const selectedItem = imageDetails.find((e)=>e.sku === colorSku) || {};
    const { imageUrl =""  } = selectedItem || {};
    return {
        ...selectedItem,
        imageUrl: "".concat(imageUrl, "?wid=300&hei=300&bgc=f9f9f9"),
        customerFacingSku
    };
};
const isAvailableInventory = (data)=>{
    const { inventory =[] , sku  } = data || {};
    const { availableQuantity =0  } = inventory.find((item)=>item.sku === sku) || {};
    return availableQuantity > 0;
};

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/context/actions/actionTypes.js
const SET_SWATCH_COLOR_NAME = "SET_SWATCH_COLOR_NAME";
const SET_SELECTED_PRODUCTS_DATA = "SET_SELECTED_PRODUCTS_DATA";
const SET_INIT_SELECTED_PRODUCTS_DATA = "SET_INIT_SELECTED_PRODUCTS_DATA";
const SET_INVENTORY_DATA = "SET_INVENTORY_DATA";
const SET_INVENTORY_STATUS = "SET_INVENTORY_STATUS";
const SET_PROJECTION_DATA = "SET_PROJECTION_DATA";

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/context/reducers.js

const initialState = {
    bundlePdp: {},
    selectedProducts: []
};
/**
 * Reducer function to handle state updates based on action types.
 *
 * @param {Object} state - The current state of the application.
 * @param {Object} action - The action dispatched to the reducer.
 * @param {string} action.type - The type of the action.
 * @param {any} action.payload - The payload of the action.
 * @return {Object} The updated state.
 */ function reducer() {
    let state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    const { type , payload  } = action;
    let updatedState;
    if (type === SET_SWATCH_COLOR_NAME) {
        updatedState = {
            ...state,
            swatchName: payload
        };
    } else if (type === SET_SELECTED_PRODUCTS_DATA) {
        const selectedItem = state.selectedProducts || [];
        const selectedProduct = selectedItem.find((item)=>item.id === payload.id);
        if (selectedProduct) {
            selectedItem[payload.id] = payload;
        } else {
            selectedItem.push(payload);
        }
        updatedState = {
            ...state,
            selectedProducts: selectedItem
        };
    } else if (type === SET_INIT_SELECTED_PRODUCTS_DATA) {
        updatedState = {
            ...state,
            selectedProducts: payload
        };
    } else if (type === SET_INVENTORY_DATA) {
        updatedState = {
            ...state,
            inventory: payload
        };
    } else if (type === SET_INVENTORY_STATUS) {
        updatedState = {
            ...state,
            inventoryStatus: payload
        };
    } else if (type === SET_PROJECTION_DATA) {
        updatedState = {
            ...state,
            projectionData: payload
        };
    } else {
        updatedState = state;
    }
    return updatedState;
}

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/context/store.js



/**
 * This is the actual context. Needs to be injected into `useContext` to
 * get store functionalities
 */ const Store = /*#__PURE__*/ (0,react.createContext)();
/**
 * Simple hook to get store.
 * @return {Object} The current store context value.
 */ const useStore = ()=>(0,react.useContext)(Store);
/**
 * This dispatcher is used to overcome the problem of not being able to use
 * hooks outside a component. It is initialized when `StoreProvider` is
 * instantiated. Use whenever actions need to be dispatched from outside
 * a component like an interceptor etc.
 */ const storeDispatcher = {
    isReady: false,
    dispatch: ()=>{
        throw new Error("Dispatch Unavailable");
    }
};
/**
 * The store provider HOC. Passes down the context to the component tree.
 * Makes the `useStore` hook usable throughout the app.
 *
 * @param {Object} props - The props for the StoreProvider component.
 * @param {React.ReactNode} props.children - The child components to render.
 * @return {JSX.Element} The provider component wrapping the children.
 */ const StoreProvider = (param)=>{
    let { children , value  } = param;
    const [state, dispatch] = (0,react.useReducer)(reducer, value || initialState);
    const storeValue = {
        state,
        dispatch
    };
    if (!storeDispatcher.isReady) {
        storeDispatcher.isReady = true;
        storeDispatcher.dispatch = (params)=>dispatch(params);
        Object.freeze(storeDispatcher);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Store.Provider, {
        value: storeValue,
        children: children
    });
};

// EXTERNAL MODULE: ./components/ProductDetail/v3/productDetailsHelper.js
var productDetailsHelper = __webpack_require__(14887);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/pdpSlice.js
var pdpSlice = __webpack_require__(44561);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/StickyHead.jsx + 2 modules
var StickyHead = __webpack_require__(24474);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(22546);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/VideoWrapper/VideoWrapper.jsx + 1 modules
var VideoWrapper = __webpack_require__(72943);
// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./styles/images/zoom-video-icon.svg
var zoom_video_icon = __webpack_require__(5025);
// EXTERNAL MODULE: ./styles/images/play-button-overlay.svg
var play_button_overlay = __webpack_require__(23043);
// EXTERNAL MODULE: ./styles/images/tap-image-zoom.svg
var tap_image_zoom = __webpack_require__(23171);
// EXTERNAL MODULE: ./styles/images/360-spin-overlay.svg
var _360_spin_overlay = __webpack_require__(326);
;// CONCATENATED MODULE: ./components/ImageGallery/v3/utlis.js


const openModal = ()=>{};
let count = 0;
const openModalAction = (param)=>{
    let { image ="" , isVideo =false , layeredImage =""  } = param;
    if (!isVideo) {
        pauseAllVideo();
    }
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    document.body.classList.add("zoom-image-scroll");
    count++;
    const element = document.querySelector(".product-details");
    element === null || element === void 0 ? void 0 : element.classList.add("zoom-image-product-section");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    document.getElementById("imageoverlay").style.display = "block";
    if (count >= 3) {
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
    document.body.classList.add("zoom-image-scroll");
    if (layeredImage && !image) {
        const layeredImageassetID = layeredImage === null || layeredImage === void 0 ? void 0 : layeredImage.split("/image/PAWEB/")[1];
        initZoomviewer(layeredImageassetID, isVideo);
    } else {
        initZoomviewer(image, isVideo);
    }
};
const initZoomviewer = function(assetID) {
    let isVideo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    const element = document.querySelector(".product-details");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    count++;
    const zoomViewer = new window.s7viewers.ZoomViewer();
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewer");
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", v2_constants/* SCENE7_SERVER_IMAGE */.aO);
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
    if (isVideo) {
        document.getElementById("s7viewer").style.display = "none";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
        const zoomPopupVideo = document.querySelector("#zoomVideo");
        if (zoomPopupVideo) {
            document.getElementById("zoomVideo").style.display = "block";
        }
    } else {
        if (zoomVideo) {
            document.getElementById("zoomVideo").style.display = "none";
        }
        document.getElementById("s7viewer").style.display = "block";
    }
    if (count >= 3) {
        const elementImage = document.querySelector("#imageoverlay");
        elementImage === null || elementImage === void 0 ? void 0 : elementImage.classList.add("zoom-activated");
    }
};
const closeZoomImage = ()=>{
    pauseAllVideo();
    const s7viewerSpinThreeSixty = document.querySelector("#s7viewerSpinThreeSixty");
    const s7viewerZoomImg = document.querySelector("#s7viewer");
    if (s7viewerZoomImg) {
        document.getElementById("s7viewer").innerHTML = "";
    }
    if (s7viewerSpinThreeSixty) {
        document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    }
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").innerHTML = "";
        document.getElementById("zoomVideo").style.display = "none";
    }
    document.body.classList.remove("zoom-image-scroll");
    const element = document.querySelector(".product-details");
    element === null || element === void 0 ? void 0 : element.classList.remove("zoom-image-product-section");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
    document.getElementById("imageoverlay").style.display = "none";
};
const zoomVideoImage = ()=>{
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "block";
    }
    document.getElementById("s7viewer").style.display = "none";
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
    document.getElementById("s7viewerSpinThreeSixty").innerHTML = "";
    const element = document.querySelector(".product-details");
    element === null || element === void 0 ? void 0 : element.classList.remove("three-sixty-image-gallery");
};
const getSlickSettings = ()=>{
    const { desktopSliderImages  } = constants.PDP_SLIDER_SIZES;
    return {
        dots: false,
        slidesToShow: desktopSliderImages,
        slidesToScroll: 3,
        swipeToSlide: true,
        swipe: true,
        arrows: true,
        infinite: false,
        centerMode: false,
        centerPadding: "0px",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4.8,
                    focusOnSelect: false,
                    centerPadding: "10px"
                }
            }
        ]
    };
};
const spin360Open = function() {
    let assetID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", zoomSpinCB = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    pauseAllVideo();
    const zoomViewer = new window.s7viewers.SpinViewer({
        handlers: {
            trackEvent: function(objID, compClass, instName, timeStamp, eventInfo) {
                zoomSpinCB(eventInfo);
            }
        }
    });
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewerSpinThreeSixty");
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", v2_constants/* SCENE7_SERVER_IMAGE */.aO);
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
    zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    const zoomVideo = document.querySelector(".zoom-video");
    if (zoomVideo) {
        document.getElementById("zoomVideo").style.display = "none";
    }
};
const spin360PdpGallery = function() {
    let assetID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", zoomSpinCBPdp = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ()=>{};
    pauseAllVideo();
    if ( true && (window === null || window === void 0 ? void 0 : window.s7viewers)) {
        const zoomViewer = new window.s7viewers.SpinViewer({
            handlers: {
                trackEvent: function(objID, compClass, instName, timeStamp, eventInfo) {
                    zoomSpinCBPdp(eventInfo);
                }
            }
        });
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setContainerId("s7viewerGallery");
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setParam("serverurl", v2_constants/* SCENE7_SERVER_IMAGE */.aO);
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.setAsset("PAWEB/".concat(assetID));
        zoomViewer === null || zoomViewer === void 0 ? void 0 : zoomViewer.init();
    }
};
const pauseAllVideo = ()=>{
    const iframes = document.querySelectorAll("iframe");
    if (iframes) {
        Array.prototype.forEach.call(iframes, (iframe)=>{
            iframe.contentWindow.postMessage(JSON.stringify({
                event: "command",
                func: "stopVideo"
            }), "*");
        });
    }
};

;// CONCATENATED MODULE: ./components/ImageGallery/v3/analytics/index.js

const addAnalyticsClickPdpImageVideo = (data)=>{
    const { index =0 , mediaType ="" , imageVideoName ="" , totalImages =0 , pdpType ="" , assetId ="" , resourceType ="n/a" , productInfo =[]  } = data;
    const imageVideoIdKey = mediaType === "image reel" ? "imageId" : "videoId";
    const imageVideoNameKey = mediaType === "image reel" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:main image click",
        eventName: "pdp:product details:main image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: assetId,
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(mediaType),
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: imageVideoName,
        resourceType,
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsClickSliderImageVideo = (data)=>{
    const { index =0 , imageVideoId ="n/a" , totalImages =0 , pdpType ="" , zoomEntryPoint ="image reel" , imageName ="n/a" , imageClick =false , resourceType ="n/a" , isThreeSixtyImage ="" , productInfo =[]  } = data;
    const imageVideoIdKey = imageClick ? "imageId" : "videoId";
    const imageVideoNameKey = imageClick ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click",
        eventName: "pdp:product details:carousel image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageVideoId,
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint).concat(isThreeSixtyImage ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint).concat(isThreeSixtyImage ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageSequence: "".concat(index, "_").concat(totalImages),
        [imageVideoIdKey]: imageVideoId,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
        resourceType,
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsClickCloseZoom = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , isThreeSixty ="" , productInfo =[]  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:close button",
        eventName: "pdp:product details:carousel image click:close button",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "close",
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint).concat(isThreeSixty ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:view gallery".concat(isThreeSixty ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsClickZoomReset = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , is360Image ="" , threeSixtyImageClick ="" , productInfo =[]  } = data;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:zoom reset"),
        eventName: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:zoom reset"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "zoom reset:applied",
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "image reel").concat(is360Image || threeSixtyImageClick ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:view gallery".concat(is360Image || threeSixtyImageClick ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsClickZoomSpinnerAndFullscreen = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image gallary" , currentImageData ={} , totalImages ="" , resourceType ="n/a" , is360Image ="" , buttonType ="" , threeSixtyImageClick ="" , screenType , productInfo =[]  } = data;
    const linkName = buttonType || screenType;
    const { type: mediaType = "" , assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const imageVideoIdKey = !mediaType ? "imageId" : "videoId";
    const imageVideoNameKey = !mediaType ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:360 ").concat(buttonType || screenType),
        eventName: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:360 ").concat(buttonType || screenType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: linkName,
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint ? zoomEntryPoint : "image gallary").concat(is360Image || threeSixtyImageClick ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:image gallery".concat(is360Image || threeSixtyImageClick ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        [imageVideoIdKey]: assetId,
        [imageVideoNameKey]: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsZoomImageSliderArrow = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , arrowLable ="right" , resourceType ="n/a" , productInfo =[]  } = data;
    const eventInfo = {
        eventAction: "pdp:product details:carousel image click:".concat(arrowLable),
        eventName: "pdp:product details:carousel image click:".concat(arrowLable),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLable, " arrow"),
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint),
        internalLinkZoneName: "pdp:product details:view gallery",
        resourceType,
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsClickZoomImage = (data)=>{
    const { pdpType ="" , zoomEntryPoint ="image reel" , zoomAction ="zoom in" , currentImageData ={} , totalImages =0 , counter , resourceType ="n/a" , is360Image ="" , counterThreeSixty ="" , productInfo  } = data;
    const { assetId: mediaAssetId = "" , url: mediaAssetURL = "" , label: mediaLabel = "n/a" , index: mediaIndex = ""  } = currentImageData;
    const assetId = mediaAssetId || mediaAssetURL;
    const eventInfo = {
        eventAction: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:").concat(zoomAction),
        eventName: "pdp:product details:".concat(is360Image ? v2_constants/* THREE_SIXTY_MAIN */.Q8 : v2_constants/* THREE_SIXTY_CAROUSEL_LABLE */.RU, " image click:").concat(zoomAction),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(zoomAction, ":applied"),
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:".concat(zoomEntryPoint, ":").concat(v2_constants/* THREE_SIXTY_LABLE */.ur),
        internalLinkZoneName: "pdp:product details:".concat(zoomEntryPoint, ":").concat(v2_constants/* THREE_SIXTY_LABLE */.ur),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        imageId: assetId,
        resourceType,
        imageName: mediaLabel ? mediaLabel.toLowerCase() : "n/a",
        imageSequence: "".concat(mediaIndex + 1, "_").concat(totalImages),
        zoomUsageDepth: "".concat(zoomAction, "_").concat(counterThreeSixty || counter),
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsPdpSlider = (data)=>{
    const { pdpImageInfo ={} , totalImages =0 , pdpType ="" , arrowLabel ="right" , resourceType ="n/a" , checkIs360Spin ="" , productInfo =[]  } = data;
    const { label: imageName = "n/a" , index: imageIndex = 0 , type: imageType = "" , assetId: imageAssetId = "" , url: imageUrl = ""  } = pdpImageInfo;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:slider main image click:".concat(arrowLabel),
        eventName: "pdp:product details:slider main image click:".concat(arrowLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLabel, " arrow"),
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:image reel".concat(checkIs360Spin ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:image reel".concat(checkIs360Spin ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        imageSequence: "".concat(imageIndex + 1, "_").concat(totalImages),
        [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addAnalyticsPdpSliderFilmStrip = (data)=>{
    const { pdpImageInfo ={} , totalImages =0 , pdpType ="" , arrowLabel ="right" , resourceType ="n/a" , productInfo =[]  } = data;
    const { label: imageName = "n/a" , index: imageIndex = 0 , type: imageType = "" , assetId: imageAssetId = "" , url: imageUrl = ""  } = pdpImageInfo;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:filmstrip main image click:".concat(arrowLabel),
        eventName: "pdp:product details:filmstrip main image click:".concat(arrowLabel),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(arrowLabel, " arrow"),
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:image reel",
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        resourceType,
        imageSequence: "".concat(imageIndex + 1, "_").concat(totalImages),
        [imageVideoIdKey]: imageType !== "video" ? imageAssetId : imageUrl,
        [imageVideoNameKey]: imageName ? imageName.toLowerCase() : "n/a",
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addPdpThumbnailAnylticsClick = (data)=>{
    const { pdpType ="" , currentIndex ="" , totalImages ="" , pdpImageInfo ={} , resourceType ="n/a" , productInfo =[]  } = data;
    const { label: imageName = "n/a" , assetId: imageAssetId = "" , type: imageType = "" , url: imageUrl = "" , resourceName ="" , resourceAltText =""  } = pdpImageInfo;
    const imageId = (resourceName === null || resourceName === void 0 ? void 0 : resourceName.length) ? resourceName === null || resourceName === void 0 ? void 0 : resourceName[0] : imageAssetId;
    const imageNamePdp = (resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText.length) ? resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0] : imageName;
    const imageVideoIdKey = imageType !== "video" ? "imageId" : "videoId";
    const imageVideoNameKey = imageType !== "video" ? "imageName" : "videoName";
    const eventInfo = {
        eventAction: "pdp:product details:thumbnail image click",
        eventName: "pdp:product details:thumbnail image click",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: imageId,
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:image reel".concat(resourceName ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkZoneName: "pdp:product details:image reel".concat(resourceName ? ":".concat(v2_constants/* THREE_SIXTY_LABLE */.ur) : ""),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        [imageVideoIdKey]: imageType !== "video" ? imageId : imageUrl,
        [imageVideoNameKey]: imageNamePdp.toLowerCase() || "n/a",
        imageSequence: "".concat(currentIndex, "_").concat(totalImages),
        resourceType,
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const addViewGalleryAnylticsClick = (data)=>{
    const { pdpType ="" , productInfo =[]  } = data;
    const eventInfo = {
        eventAction: "pdp:product details:thumbnail image click:view gallery",
        eventName: "pdp:product details:thumbnail image click:view gallery",
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "view gallery",
        internalLinkPosition: "pdp:".concat(pdpType),
        internalLinkType: "pdp:image reel",
        internalLinkZoneName: "pdp:product details:image reel",
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        modalName: pdpType
    };
    pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const page = window.pageObj || {};
    const event = "cmp:click";
    let objDL = {
        event,
        eventInfo,
        page
    };
    if (productInfo) {
        productInfo.forEach((item)=>{
            item.productImageGallery = true;
        });
        objDL = {
            ...objDL,
            productInfo: productInfo
        };
    }
    window.adobeDataLayer.push(objDL);
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(4839);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./styles/images/zoom-close-icon.svg
var zoom_close_icon = __webpack_require__(11812);
;// CONCATENATED MODULE: ./components/ImageGallery/v3/ImageHeroSection.jsx








const ImageHeroSection = (props)=>{
    const { data =[] , pdpCustomImagesArray =[] , zoomVideoId ="" , closeZoomImageClick ="" , iframeContainer =null , closeZoomImageModel ="" , currentVideoId ="" , zoomEntryPoint ="" , getVideoInfo =()=>{} , width =0 , activeImage ="" , slickRef =null , threeSixtyZoomClick =false , threeSixtyOpen =()=>{} , assetAccountName ="" , appendPresetToUrl =()=>{} , swatchUrl ="" , presetConfigObject ={} , imageZoomClick =()=>{} , zoomVideoIcon ={} , initialImgUrl ="" , pdpDesktopImage ="" , imageZoomVideoClick =()=>{} , initialImgAlt =""  } = props;
    const pdpImageArrayLength = pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "image-overlay ".concat(zoomVideoId ? "video-open" : ""),
            id: "imageoverlay",
            tabIndex: 90,
            role: "dialog",
            "aria-labelledby": "gallery-pdp",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "close-zoom-image",
                    onClick: closeZoomImageClick,
                    tabIndex: 91,
                    role: "dialog",
                    "aria-labelledby": "close",
                    "aria-label": closeZoomImageModel,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: zoom_close_icon/* default */.Z === null || zoom_close_icon/* default */.Z === void 0 ? void 0 : zoom_close_icon/* default.src */.Z.src,
                        role: "button",
                        alt: "close",
                        tabIndex: 152
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "popup-content",
                    tabIndex: 93,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "iframe-container",
                        ref: iframeContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "s7viewer",
                                tabIndex: 99
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "s7viewerSpinThreeSixty",
                                tabIndex: 99
                            }),
                            zoomVideoId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "zoom-video",
                                id: "zoomVideo",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                    videoId: zoomVideoId,
                                    width: "100%",
                                    playVideoClick: true,
                                    index: currentVideoId,
                                    totalPdpImages: pdpImageArrayLength,
                                    zoomEntryPoint: zoomEntryPoint,
                                    getVideoInfo: getVideoInfo
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "gallery",
                                id: "gallery-pdp",
                                tabIndex: 150,
                                role: "dialog",
                                "aria-labelledby": "myLargeModalLabel3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                    ...getSlickSettings(width),
                                    ref: (ref)=>slickRef.current = ref,
                                    tabIndex: 151,
                                    children: data && pdpCustomImagesArray && pdpImageArrayLength ? pdpCustomImagesArray.map((element, i)=>{
                                        var ref, ref1, ref2;
                                        const resourcePdpImageName = (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0]) || "";
                                        const layerImageResourse = element === null || element === void 0 ? void 0 : element.layerUrl;
                                        const resourcePdpImageUrl = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
                                        const resourcePdpImageAlt = (element === null || element === void 0 ? void 0 : (ref2 = element.resourceAltText) === null || ref2 === void 0 ? void 0 : ref2[0]) || "";
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                            children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "image-wrapper ".concat((element === null || element === void 0 ? void 0 : element.assetId) === activeImage || resourcePdpImageName === activeImage || layerImageResourse === activeImage ? "imageActive " : "", " \n                              ").concat(resourcePdpImageUrl && resourcePdpImageName ? "overlay-image-360 " : "", "\n                              ").concat((element === null || element === void 0 ? void 0 : element.assetId) === activeImage && threeSixtyZoomClick || resourcePdpImageName === activeImage && !threeSixtyZoomClick ? "remove-border " : "", "\n                              "),
                                                children: resourcePdpImageUrl && resourcePdpImageName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "zoom-three-sixty",
                                                    onClick: ()=>threeSixtyOpen(resourcePdpImageName, resourcePdpImageAlt, i),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                            role: "img",
                                                            src: resourcePdpImageUrl,
                                                            alt: resourcePdpImageAlt,
                                                            width: 60,
                                                            height: 60
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "zoom-video-icon",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: _360_spin_overlay/* default */.Z === null || _360_spin_overlay/* default */.Z === void 0 ? void 0 : _360_spin_overlay/* default.src */.Z.src,
                                                                alt: resourcePdpImageAlt,
                                                                tabIndex: "10 ".concat(+i)
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    role: "img",
                                                    src: layerImageResourse ? layerImageResourse : appendPresetToUrl(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                                    alt: element.label,
                                                    width: 60,
                                                    height: 60,
                                                    tabIndex: "10".concat(+i),
                                                    onClick: ()=>{
                                                        return imageZoomClick(layerImageResourse || element.assetId, i, element === null || element === void 0 ? void 0 : element.label);
                                                    }
                                                })
                                            }, "zoom-image-".concat(element === null || element === void 0 ? void 0 : element.assetId)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                onClick: ()=>imageZoomVideoClick(element.url, i),
                                                className: "image-wrapper zoom-video-section ".concat(element.url === activeImage ? "imageActive" : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                                        thumb: true,
                                                        videoId: element.url,
                                                        getVideoInfo: getVideoInfo,
                                                        index: i,
                                                        totalPdpImages: pdpImageArrayLength,
                                                        zoomEntryPoint: zoomEntryPoint
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "zoom-video-icon",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: zoomVideoIcon === null || zoomVideoIcon === void 0 ? void 0 : zoomVideoIcon.src,
                                                            alt: "zoom video",
                                                            tabIndex: 110 + i
                                                        })
                                                    })
                                                ]
                                            }, "zoom-video-".concat(i))
                                        }, "imageg".concat(i));
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image-wrapper imageActive",
                                        children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            role: "button",
                                            src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                                            alt: initialImgAlt,
                                            tabIndex: "105",
                                            className: "print",
                                            onClick: ()=>imageZoomClick(initialImgUrl, 0, initialImgAlt)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__para shimmer height-400"
                                        })
                                    })
                                }, "slider-zoom-gallery")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v3_ImageHeroSection = (ImageHeroSection);

;// CONCATENATED MODULE: ./components/ImageGallery/v3/ImageReel.jsx



















const ImageReel = (props)=>{
    var ref;
    const { data =[] , isModel =false , swatchUrl ="" , productInfo =[] , isHorizontal =false , galleryStackId ="" , assetAccountName ="" , imageClickCounter =1 , presetConfigObject ={} , productGalleryLabel ={} , initialImgAlt ="" , initialImgUrl ="" , pdpDesktopImage ="" , productImagesWithUrls ={} , threeSixtyResourceData ={} , clickedProductVariant =false , layerImageData ={}  } = props || {};
    swiper_esm/* default.use */.ZP.use([
        swiper_esm/* Thumbs */.o3,
        swiper_esm/* Keyboard */.N1,
        swiper_esm/* Mousewheel */.Gk,
        swiper_esm/* A11y */.s5,
        swiper_esm/* Scrollbar */.LW,
        swiper_esm/* FreeMode */.Rv
    ]);
    const swiperThumbRef = (0,react.useRef)(null);
    const swiperPdpRef = (0,react.useRef)(null);
    const iframeContainer = (0,react.useRef)(null);
    const threeSixtyIframeContainer = (0,react.useRef)(null);
    const pdpType = (productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo[0]) === null || ref === void 0 ? void 0 : ref.pdpType) || "";
    const { resourceFullWebUrl ="" , resourceName ="" , resourceTypeImg ="" , resourceAltText =""  } = threeSixtyResourceData;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [activeImage, setactiveImage] = (0,react.useState)(null);
    const [zoomVideoId, setZoomVideoId] = (0,react.useState)(null);
    const [currentVideoId, setCurrentVideoId] = (0,react.useState)(null);
    const [zoomEntryPoint, setZoomEntryPoint] = (0,react.useState)(null);
    const [thumbnailClicked, setThumbnailClicked] = (0,react.useState)(false);
    const [threeSixtyZoomClick, setThreeSixtyZoomClick] = (0,react.useState)(false);
    const [currentSlide, setCurrentSlide] = (0,react.useState)(0);
    const [isThreeSixtyRender, setIsThreeSixtyRender] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const [thumbsSwiper, setThumbsSwiper] = (0,react.useState)(null);
    const slickRef = (0,react.useRef)(null);
    const totalImages = isHorizontal ? data.length : 3;
    const { largeIpadSize , imageReelTitle , mobileSize  } = constants.PDP_SLIDER_SIZES;
    const resourceCredits = productGalleryLabel && productGalleryLabel.resourceCredit_s && productGalleryLabel.resourceCredit_s.match("http") == null ? productGalleryLabel.resourceCredit_s : "";
    const imageSequence = imageClickCounter ? imageClickCounter + 1 : null;
    const pdpImages = data === null || data === void 0 ? void 0 : data.reduce((acc, ini)=>{
        if (acc.filter((item)=>item.assetId === ini.assetId).length === 0 || ini.type === "video") {
            acc.push(ini);
        }
        return acc;
    }, []);
    const allPdpImages = [
        ...pdpImages.filter((item)=>!item.type),
        threeSixtyResourceData,
        ...pdpImages.filter((item)=>item.type === "video")
    ];
    if ((layerImageData === null || layerImageData === void 0 ? void 0 : layerImageData.layerUrl) !== "") {
        if (!(layerImageData === null || layerImageData === void 0 ? void 0 : layerImageData.layerUrl.includes("<<IMAGE"))) {
            allPdpImages.unshift({
                ...layerImageData,
                assetId: layerImageData === null || layerImageData === void 0 ? void 0 : layerImageData.layerUrl.split("/image/PAWEB/")[1]
            });
        }
    }
    (0,react.useEffect)(()=>{
        var ref, ref1;
        (ref = swiperThumbRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideTo(0);
        (ref1 = swiperPdpRef.current) === null || ref1 === void 0 ? void 0 : ref1.swiper.slideTo(0);
    }, [
        layerImageData === null || layerImageData === void 0 ? void 0 : layerImageData.layerUrl
    ]);
    const pdpCustomImagesArray = allPdpImages.filter((value)=>Object.keys(value).length !== 0);
    const pdpImageArrayLength = pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length;
    let fullScreenTimer;
    const ZoomValue = (0,react.useRef)(0);
    const ZoomValuePDP = (0,react.useRef)(0);
    const zoomSpinCBPdp = (eventInfo)=>{
        const [eventType, eventValue] = eventInfo.split(",");
        if (eventType === "SPIN" && eventValue > 0) {
            zoom360SpinnerClickAction();
        } else if (eventType === "ZOOM" && (eventValue !== 0 || eventValue !== 100)) {
            if (Number(ZoomValuePDP.current) > Number(eventValue)) {
                zoomOut360ButtonClickAction({
                    is360Image: true,
                    isImageGallery: true
                });
            } else {
                zoomInButton360ClickAction({
                    is360Image: true,
                    isImageGallery: true
                });
            }
            ZoomValuePDP.current = eventValue;
            ZoomValue.current = 0;
        }
    };
    const zoomSpinCB = (eventInfo)=>{
        const [eventType, eventValue] = eventInfo.split(",");
        if (eventType === "SPIN" && eventValue > 0) {
            zoom360CarasoulSpinnerClickAction();
        } else if (eventType === "ZOOM" && (eventValue !== 0 || eventValue !== 100)) {
            if (Number(ZoomValue.current) > Number(eventValue)) {
                zoomOut360ButtonClickAction({
                    is360Image: false,
                    isImageGallery: true
                });
            } else {
                zoomInButton360ClickAction({
                    is360Image: false,
                    isImageGallery: true
                });
            }
            ZoomValue.current = eventValue;
            ZoomValuePDP.current = 0;
        }
    };
    const threeSixtyOpen = function() {
        let assetId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", imageLable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        if (assetId) {
            setactiveImage("");
            setactiveImage(assetId);
            setThreeSixtyZoomClick(true);
            const s7viewerZoom = document.querySelector("#s7viewer");
            if (s7viewerZoom) {
                document.getElementById("s7viewer").innerHTML = "";
            }
            document.getElementById("s7viewer").style.display = "none";
            document.getElementById("s7viewerSpinThreeSixty").style.display = "block";
            const element = document.querySelector(".product-details");
            element === null || element === void 0 ? void 0 : element.classList.add("three-sixty-image-gallery");
            spin360Open(assetId, zoomSpinCB);
            addAnalyticsClickSliderImageVideo({
                index: i + 1,
                imageVideoId: assetId,
                totalImages: pdpImageArrayLength,
                pdpType,
                zoomEntryPoint: zoomEntryPoint,
                imageLable,
                imageClick: true,
                resourceType: resourceTypeImg.length ? resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase() : "n/a",
                isThreeSixtyImage: true,
                productInfo
            });
        }
    };
    const isOnePdpImage = initialImgUrl && pdpDesktopImage ? initialImgUrl : "";
    const firstImageForZoom = data && (pdpImages === null || pdpImages === void 0 ? void 0 : pdpImages.length) ? pdpImages[0].assetId : isOnePdpImage;
    const beforeChangeHandler = function() {
        let swiper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const elementThumbSlider = document.querySelector(".pdp-thumbnail-vertical .swiper-slide");
        if (elementThumbSlider) {
            elementThumbSlider === null || elementThumbSlider === void 0 ? void 0 : elementThumbSlider.classList.remove("imageActiveThumb");
        }
        const current = swiper === null || swiper === void 0 ? void 0 : swiper.previousIndex;
        const next = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex;
        setCurrentSlide(next);
        setActiveIndex(next);
        const imagesLength = allPdpImages.filter((item)=>!item.type).length;
        const checkIs360Spin = (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) && next === imagesLength;
        if (next === imagesLength) {
            if ((resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0])) {
                document.getElementById("s7viewerGallery").innerHTML = "";
                spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
            }
        }
        if (width <= largeIpadSize && (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0])) {
            document.body.classList.remove("full-screen-open");
            document.body.style.overflow = "";
        }
        pauseAllVideo();
        const elementSlider = document.querySelector(".pdp-thumbnail-vertical");
        elementSlider === null || elementSlider === void 0 ? void 0 : elementSlider.classList.add("pdp-slide-change");
        const arrowLabel = current > next ? "left" : "right";
        const pdpImageInfo = allPdpImages === null || allPdpImages === void 0 ? void 0 : allPdpImages.map((item, index)=>({
                ...item,
                index
            })).find((item)=>{
            return (item === null || item === void 0 ? void 0 : item.index) === next;
        });
        if (thumbnailClicked) {
            setThumbnailClicked(false);
        } else {
            addAnalyticsPdpSlider({
                pdpImageInfo,
                totalImages: pdpImageArrayLength,
                pdpType,
                arrowLabel,
                resourceType: checkImageResoruceType(pdpImageInfo === null || pdpImageInfo === void 0 ? void 0 : pdpImageInfo.assetId) || "",
                checkIs360Spin,
                productInfo
            });
        }
    };
    const beforeChangeHandlerFilmStrip = function() {
        let swiper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        const current = swiper === null || swiper === void 0 ? void 0 : swiper.previousIndex;
        const next = swiper === null || swiper === void 0 ? void 0 : swiper.realIndex;
        if (width < largeIpadSize) {
            const arrowLabel = current > next ? "left" : "right";
            const pdpImageInfo = allPdpImages === null || allPdpImages === void 0 ? void 0 : allPdpImages.map((item, index)=>({
                    ...item,
                    index
                })).find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.index) === next;
            });
            addAnalyticsPdpSliderFilmStrip({
                pdpImageInfo,
                totalImages: pdpImageArrayLength,
                pdpType,
                arrowLabel,
                resourceType: checkImageResoruceType(pdpImageInfo === null || pdpImageInfo === void 0 ? void 0 : pdpImageInfo.assetId) || "",
                productInfo
            });
        }
    };
    const handleOpenModal = ()=>{
        openModal(window.s7viewers);
        window.addEventListener("keydown", handleKey);
    };
    (0,react.useEffect)(()=>{
        handleOpenModal();
        if ((resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) && (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0])) {
            spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
        }
    }, []);
    (0,react.useEffect)(()=>{
        if ((swiperThumbRef === null || swiperThumbRef === void 0 ? void 0 : swiperThumbRef.current) && clickedProductVariant && (swiperPdpRef === null || swiperPdpRef === void 0 ? void 0 : swiperPdpRef.current) && (data === null || data === void 0 ? void 0 : data.length)) {
            var ref, ref1;
            (ref = swiperThumbRef.current) === null || ref === void 0 ? void 0 : ref.swiper.slideTo(0);
            (ref1 = swiperPdpRef.current) === null || ref1 === void 0 ? void 0 : ref1.swiper.slideTo(0);
            setActiveIndex(0);
        }
    }, [
        clickedProductVariant
    ]);
    let isZoomClick = false;
    const slickGotoSlider = (sliderNumber)=>{
        slickRef.current.slickGoTo(sliderNumber);
    };
    const openImageZoom = function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currentImageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", element = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, layerImageResourse = arguments.length > 4 ? arguments[4] : void 0;
        var ref, ref1;
        if ((element === null || element === void 0 ? void 0 : (ref = element.resourceFullWebUrl) === null || ref === void 0 ? void 0 : ref[0]) && (element === null || element === void 0 ? void 0 : (ref1 = element.resourceName) === null || ref1 === void 0 ? void 0 : ref1[0])) {
            var ref2, ref3;
            spin360Open(element === null || element === void 0 ? void 0 : (ref2 = element.resourceName) === null || ref2 === void 0 ? void 0 : ref2[0], zoomSpinCB);
            setactiveImage("");
            setactiveImage(element === null || element === void 0 ? void 0 : (ref3 = element.resourceName) === null || ref3 === void 0 ? void 0 : ref3[0]);
        } else {
            const resourceType = checkImageResoruceType(image);
            setZoomEntryPoint("image gallery");
            setZoomVideoId("");
            setactiveImage("");
            setactiveImage(image || layerImageResourse);
            openModalAction({
                image: image,
                layeredImage: layerImageResourse
            });
            if (width < mobileSize) {
                slickGotoSlider(i);
            }
            addAnalyticsClickPdpImageVideo({
                index: i + 1,
                mediaType: imageReelTitle,
                imageVideoName: currentImageName || "n/a",
                totalImages: pdpImageArrayLength,
                pdpType,
                assetId: image || layerImageResourse.split("/image/PAWEB/")[1],
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase(),
                productInfo
            });
        }
    };
    const viewGalleryImageClick = (0,react.useCallback)(function() {
        let imageAssetID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        setZoomEntryPoint("image gallery");
        setactiveImage(imageAssetID);
        if (imageAssetID.includes("/image/PAWEB/")) {
            openModalAction({
                layeredImage: imageAssetID
            });
        } else {
            openModalAction({
                image: imageAssetID
            });
        }
    });
    const imageZoomClick = function() {
        let image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, imageName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", element = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        setThreeSixtyZoomClick(false);
        document.getElementById("s7viewerSpinThreeSixty").style.display = "none";
        document.getElementById("s7viewer").style.display = "block";
        if (image) {
            let layeredImageassetID = "";
            const resourceType = checkImageResoruceType(image);
            setZoomVideoId("");
            setactiveImage("");
            if (image.includes("/image/PAWEB/")) {
                layeredImageassetID = image.split("/image/PAWEB/")[1];
                initZoomviewer(layeredImageassetID);
            } else {
                initZoomviewer(image);
            }
            setactiveImage(image);
            addAnalyticsClickSliderImageVideo({
                index: i + 1,
                imageVideoId: layeredImageassetID || image,
                totalImages: pdpImageArrayLength,
                pdpType,
                zoomEntryPoint: zoomEntryPoint,
                imageName,
                imageClick: true,
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase(),
                isThreeSixtyImage: false,
                productInfo
            });
            setTabIndexGallery();
        }
    };
    const imageZoomVideoClick = function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        setZoomVideoId(video);
        setactiveImage("");
        setActiveIndex(i);
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setactiveImage(video);
        setCurrentVideoId(i + 1);
        zoomVideoImage();
        setTabIndexGallery();
    };
    const getVideoInfo = function() {
        let targetElement = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", videoId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        addAnalyticsClickSliderImageVideo({
            index,
            imageVideoId: videoId,
            totalImages: pdpImageArrayLength,
            pdpType,
            zoomEntryPoint: zoomEntryPoint,
            imageName: targetElement === null || targetElement === void 0 ? void 0 : targetElement.videoTitle,
            imageClick: false,
            isThreeSixtyImage: false,
            productInfo
        });
    };
    const imageZoomMobileVideoClick = function() {
        let video = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (width < 1023) {
            setZoomEntryPoint(imageReelTitle);
        }
        setactiveImage("");
        setCurrentVideoId(i + 1);
        setZoomVideoId(video);
        if (width < mobileSize) {
            slickGotoSlider(i);
        }
        openModalAction({
            image: video,
            isVideo: true
        });
        setactiveImage(video);
    };
    const closeZoomImageClick = (0,react.useCallback)(()=>{
        const checkIsThreeSixty = document.querySelector(".three-sixty-image-gallery");
        counter = 0;
        zoomOutCounter = 0;
        setZoomVideoId(false);
        closeZoomImage();
        let currentImageData = {};
        let resourceType = null;
        if (checkIsThreeSixty) {
            currentImageData = {
                assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
                label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
                index: 1
            };
            resourceType = (resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].length) ? resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase() : null;
        } else {
            currentImageData = pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.map((item, index)=>({
                    ...item,
                    index
                })).find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
            });
            resourceType = checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || null;
        }
        addAnalyticsClickCloseZoom({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImageArrayLength,
            productInfo,
            resourceType,
            isThreeSixty: checkIsThreeSixty
        });
    });
    const currentImageData = allPdpImages === null || allPdpImages === void 0 ? void 0 : allPdpImages.map((item, index)=>({
            ...item,
            index
        })).find((item)=>{
        return (item === null || item === void 0 ? void 0 : item.assetId) === activeImage || (item === null || item === void 0 ? void 0 : item.url) === activeImage;
    });
    (0,react.useEffect)(()=>{
        let zoomImageClick = null;
        let zoomGallaryAddEventListner;
        if ((iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current) && activeImage && zoomEntryPoint && !zoomGallaryAddEventListner) {
            zoomGallaryAddEventListner = setTimeout(()=>{
                var ref, ref1, ref2, ref3, // Add fullscreen click
                ref4;
                const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                if (zoomInButtonClick) {
                    setTabIndexGallery();
                    zoomInButtonClick.addEventListener("click", (e)=>{
                        var ref, ref1;
                        var ref2;
                        const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
                        !threeSixtyImageClick && zoomInButtonClickAction();
                    }, false);
                }
                (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref = iframeContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector(".s7button.s7zoomoutbutton")) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", (e)=>{
                    var ref, ref1;
                    var ref2;
                    const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
                    !threeSixtyImageClick && zoomOutButtonClickAction();
                }, false);
                (ref3 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref2 = iframeContainer.current) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".s7button.s7zoomresetbutton")) === null || ref3 === void 0 ? void 0 : ref3.addEventListener("click", zoomResetButtonClickAction, false);
                (ref4 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref4 === void 0 ? void 0 : ref4.addEventListener("click", zoom360CarasoulFullScreenClickAction, false);
                zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
                if (zoomImageClick) {
                    if (width <= largeIpadSize) {
                        zoomImageClick.addEventListener("touchstart", (ev)=>{
                            setTimeout(function() {
                                zoomImageIconAction();
                            }, 1000);
                        }, false);
                    }
                }
                if (zoomImageClick) {
                    const delta = 6;
                    let startX;
                    let startY;
                    zoomImageClick.addEventListener("mousedown", function(event) {
                        startX = event.pageX;
                        startY = event.pageY;
                        isZoomClick = true;
                    });
                    zoomImageClick.addEventListener("mouseup", function(event) {
                        const diffX = Math.abs(event.pageX - startX);
                        const diffY = Math.abs(event.pageY - startY);
                        isZoomClick = true;
                        if (diffX < delta && diffY < delta) {
                            isZoomClick = false;
                        }
                    });
                    zoomImageClick.addEventListener("click", zoomImageClickAction, false);
                }
            }, 500);
            const silckSliderNext = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-next");
            if (silckSliderNext) {
                silckSliderNext.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "right",
                        currentImageData,
                        totalImages: pdpImageArrayLength,
                        productInfo,
                        resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || null
                    });
                });
            }
            const silckSliderPrev = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".slick-prev");
            if (silckSliderPrev) {
                silckSliderPrev.addEventListener("click", (e)=>{
                    e.preventDefault();
                    addAnalyticsZoomImageSliderArrow({
                        pdpType,
                        zoomEntryPoint,
                        arrowLable: "left",
                        currentImageData,
                        totalImages: pdpImageArrayLength,
                        productInfo,
                        resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId) || ""
                    });
                });
            }
        }
        return ()=>{
            if (zoomGallaryAddEventListner) {
                clearTimeout(zoomGallaryAddEventListner);
                zoomGallaryRemoveEventListner();
            }
        };
    }, [
        iframeContainer,
        zoomEntryPoint,
        activeImage
    ]);
    const zoomGallaryRemoveEventListner = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, // Remove fullscreen click
        ref8;
        (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref = iframeContainer.current) === null || ref === void 0 ? void 0 : ref.querySelector(".s7zoomview")) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", zoomImageClickAction, false);
        (ref3 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref2 = iframeContainer.current) === null || ref2 === void 0 ? void 0 : ref2.querySelector(".s7button.s7zoominbutton")) === null || ref3 === void 0 ? void 0 : ref3.removeEventListener("click", (e)=>{
            var ref, ref1;
            var ref2;
            const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
            !threeSixtyImageClick && zoomInButtonClickAction();
        }, false);
        (ref5 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref4 = iframeContainer.current) === null || ref4 === void 0 ? void 0 : ref4.querySelector(".s7button.s7zoomoutbutton")) === null || ref5 === void 0 ? void 0 : ref5.removeEventListener("click", (e)=>{
            var ref, ref1;
            var ref2;
            const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
            !threeSixtyImageClick && zoomOutButtonClickAction();
        }, false);
        (ref7 = iframeContainer === null || iframeContainer === void 0 ? void 0 : (ref6 = iframeContainer.current) === null || ref6 === void 0 ? void 0 : ref6.querySelector(".s7button.s7zoomresetbutton")) === null || ref7 === void 0 ? void 0 : ref7.removeEventListener("click", zoomResetButtonClickAction, false);
        (ref8 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref8 === void 0 ? void 0 : ref8.removeEventListener("click", zoom360CarasoulFullScreenClickAction, false);
    };
    // 360 zoom icon code start
    (0,react.useEffect)(()=>{
        let threeSixtyAddEventListners;
        if (currentSlide === 1 && (threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current)) {
            threeSixtyAddEventListners = setTimeout(()=>{
                var // Add fullscreen click
                ref, ref1;
                (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref === void 0 ? void 0 : ref.addEventListener("click", zoom360FullScreenClickAction, false);
                (ref1 = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector("#s7viewerGallery")) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", zoomInButton360full, false);
            }, 500);
        }
        return ()=>{
            if (threeSixtyAddEventListners) {
                clearTimeout(threeSixtyAddEventListners);
                threeSixtyRemoveEventListners();
                setIsThreeSixtyRender(false);
            }
        };
    }, [
        currentSlide,
        isThreeSixtyRender
    ]);
    const threeSixtyRemoveEventListners = ()=>{
        var // Remove fullscreen click
        ref, ref1;
        (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7button.s7fullscreenbutton")) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", zoom360FullScreenClickAction, false);
        (ref1 = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector("#s7viewerGallery")) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", zoomInButton360full, false);
        clearTimeout(fullScreenTimer);
        clearTimeout(fullScreenTabTimer);
    };
    let counterThreeSixty = 0;
    let counterThreeSixtyZoomOut = 0;
    const zoomInButton360ClickAction = (param)=>{
        let { is360Image =false , isImageGallery =false  } = param;
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        counterThreeSixty++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
            zoomAction: "zoom in",
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            counterThreeSixty,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            productInfo
        });
    };
    const zoomOut360ButtonClickAction = (param)=>{
        let { is360Image =false , isImageGallery =false  } = param;
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        counterThreeSixtyZoomOut++;
        addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
            zoomAction: "zoom out",
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            counter: counterThreeSixtyZoomOut,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            productInfo
        });
    };
    const zoom360CarasoulSpinnerClickAction = ()=>{
        zoom360SpinnerClickAction(false, true);
    };
    const zoom360SpinnerClickAction = function() {
        let is360Image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, threeSixtyImageClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, spinType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
        setTabIndexGallery();
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        addAnalyticsClickZoomSpinnerAndFullscreen({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            buttonType: "spin interaction",
            threeSixtyImageClick,
            spinType,
            productInfo
        });
    };
    const zoom360CarasoulFullScreenClickAction = ()=>{
        zoom360FullScreenClickAction(false, true);
    };
    const zoomInButton360full = ()=>{
        if (width <= largeIpadSize) {
            const threeSixtyData = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container");
            const zoomCursorType = threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.getAttribute("mode");
            if (zoomCursorType === "fullscreen") {
                document.body.style.overflow = "";
            }
        }
    };
    const zoom360FullScreenClickAction = function() {
        let is360Image = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, threeSixtyImageClick = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref, ref1;
        setTabIndexGallery();
        if (width <= largeIpadSize) {
            fullScreenTimer = setTimeout(function() {
                const threeSixtyData = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container");
                if (threeSixtyData) {
                    threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.addEventListener("click", zoomInButton360full, false);
                }
                const zoomCursorType = threeSixtyData === null || threeSixtyData === void 0 ? void 0 : threeSixtyData.getAttribute("mode");
                if (zoomCursorType === "fullscreen") {
                    document.body.classList.add("full-screen-open");
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                } else {
                    document.body.style.overflow = "";
                    document.body.classList.remove("full-screen-open");
                    document.getElementById("s7viewerGallery").innerHTML = "";
                    if (resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) {
                        spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0], zoomSpinCBPdp);
                        setIsThreeSixtyRender(true);
                    }
                }
            }, 100);
        }
        const currentImageData = {
            assetId: resourceName === null || resourceName === void 0 ? void 0 : resourceName[0],
            label: resourceAltText === null || resourceAltText === void 0 ? void 0 : resourceAltText[0],
            index: 1
        };
        const screenTypeGallary = (ref = threeSixtyIframeContainer === null || threeSixtyIframeContainer === void 0 ? void 0 : threeSixtyIframeContainer.current.querySelector(".s7container")) === null || ref === void 0 ? void 0 : ref.getAttribute("mode");
        const screenTypeMain = (ref1 = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7container")) === null || ref1 === void 0 ? void 0 : ref1.getAttribute("mode");
        let screenType = "";
        if (!is360Image) {
            screenType = screenTypeMain === "normal" ? "full screen" : "minimise";
        } else {
            screenType = screenTypeGallary === "normal" ? "full screen" : "minimise";
        }
        addAnalyticsClickZoomSpinnerAndFullscreen({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.length,
            resourceType: resourceTypeImg === null || resourceTypeImg === void 0 ? void 0 : resourceTypeImg[0].toLowerCase(),
            is360Image,
            threeSixtyImageClick,
            screenType,
            productInfo
        });
    };
    // 360 zoom icon code end
    let counter = 0;
    let zoomOutCounter = 0;
    let fullScreenTabTimer;
    const zoomImageClickAction = (0,react.useCallback)((e)=>{
        const zoomImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7zoomview");
        const cursortype = zoomImageClick === null || zoomImageClick === void 0 ? void 0 : zoomImageClick.getAttribute("cursortype");
        if (width <= largeIpadSize) {
            isZoomClick = false;
        }
        setTimeout(function() {
            setTabIndexGallery();
        }, 1000);
        if (!isZoomClick) {
            setTimeout(function() {
                setTabIndexGallery();
                checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId);
                if (cursortype !== "reset" || cursortype !== "drag") {
                    setTabIndexGallery();
                    if (cursortype === "zoomin") {
                        counter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom in",
                            currentImageData,
                            totalImages: pdpImageArrayLength,
                            counter,
                            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                            is360Image: false,
                            productInfo
                        });
                    } else {
                        zoomOutCounter++;
                        addAnalyticsClickZoomImage({
                            pdpType,
                            zoomEntryPoint,
                            zoomAction: "zoom out",
                            currentImageData,
                            totalImages: pdpImageArrayLength,
                            counter: zoomOutCounter,
                            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                            is360Image: false,
                            productInfo
                        });
                    }
                }
            }, 50);
        }
    });
    const zoomInButtonClickAction = (0,react.useCallback)(()=>{
        const threeSixtyImageClick = false;
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                const zoomCursorType = zoomInImageClick.getAttribute("state");
                if (!threeSixtyImageClick) {
                    if (zoomCursorType === "disabled") {
                        zoomInImageClick.setAttribute("style", "display: none !important");
                        zoomImageOutClick.setAttribute("style", "display: block !important");
                    } else {
                        zoomInImageClick.setAttribute("style", "display: block !important");
                        zoomImageOutClick.setAttribute("style", "display: none !important");
                    }
                }
            }, 1000);
        }
        counter++;
        !threeSixtyImageClick && addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom in",
            currentImageData,
            totalImages: pdpImageArrayLength,
            counter,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick,
            productInfo
        });
        setTabIndexGallery();
    });
    const zoomOutButtonClickAction = (0,react.useCallback)(()=>{
        zoomOutCounter++;
        const threeSixtyImageClick = false;
        !threeSixtyImageClick && addAnalyticsClickZoomImage({
            pdpType,
            zoomEntryPoint,
            zoomAction: "zoom out",
            currentImageData,
            totalImages: pdpImageArrayLength,
            counter: zoomOutCounter,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick,
            productInfo
        });
        if (width <= largeIpadSize) {
            setTimeout(function() {
                const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
                const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
                if (!threeSixtyImageClick) {
                    const zoomCursorType = zoomImageOutClick.getAttribute("state");
                    if (zoomCursorType === "disabled") {
                        zoomInImageClick.setAttribute("style", "display: block !important");
                        zoomImageOutClick.setAttribute("style", "display: none !important");
                    } else {
                        zoomInImageClick.setAttribute("style", "display: none !important");
                        zoomImageOutClick.setAttribute("style", "display: block !important");
                    }
                }
            }, 1000);
        }
    });
    const zoomResetButtonClickAction = (0,react.useCallback)((e)=>{
        var ref, ref1;
        counter = 0;
        zoomOutCounter = 0;
        var ref2;
        const threeSixtyImageClick = (ref2 = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.includes("ThreeSixty")) !== null && ref2 !== void 0 ? ref2 : false;
        !threeSixtyImageClick && addAnalyticsClickZoomReset({
            pdpType,
            zoomEntryPoint,
            currentImageData,
            totalImages: pdpImageArrayLength,
            resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
            is360Image: false,
            threeSixtyImageClick,
            productInfo
        });
    });
    const lastTabIndex = 0;
    let currentIndex = 90;
    const handleKey = ()=>{
        window.addEventListener("focusin", function() {
            currentIndex = document.activeElement.tabIndex;
        }, true);
        let curIndex = currentIndex;
        if (curIndex === lastTabIndex) {
            curIndex = 90;
        }
        const tabbables = document.querySelectorAll(".image-overlay");
        for(let i = 0; i < tabbables.length; i++){
            if (tabbables[i].tabIndex === curIndex) {
                tabbables[i].focus();
                break;
            }
        }
    };
    const setTabIndexGallery = ()=>{
        fullScreenTabTimer = setTimeout(function() {
            const zoomInButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
            const zoomOutButtonClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomoutbutton");
            const zoomResetButton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoomresetbutton");
            const zoomLeftArrow = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7panleftbutton");
            const zoomRightArrow = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7panrightbutton");
            const zooms7fullscreenbutton = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7fullscreenbutton");
            if (zoomInButtonClick) {
                zoomInButtonClick.setAttribute("tabindex", "96");
                zoomOutButtonClick.setAttribute("tabindex", "97");
                zoomResetButton.setAttribute("tabindex", "98");
            }
            if (zoomLeftArrow || zoomRightArrow) {
                zoomLeftArrow.setAttribute("tabindex", "98");
                zoomRightArrow.setAttribute("tabindex", "98");
            }
            if (zooms7fullscreenbutton) {
                zooms7fullscreenbutton.setAttribute("tabindex", "98");
            }
        }, 100);
    };
    const zoomImageIconAction = ()=>{
        const zoomInImageClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector(".s7button.s7zoominbutton");
        const zoomImageOutClick = iframeContainer === null || iframeContainer === void 0 ? void 0 : iframeContainer.current.querySelector("#s7viewer_zoomOutButton");
        const zoomCursorType = zoomInImageClick.getAttribute("state");
        if (zoomCursorType === "disabled") {
            zoomOutCounter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom out",
                currentImageData,
                totalImages: pdpImageArrayLength,
                counter: zoomOutCounter,
                resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                is360Image: false,
                productInfo
            });
            zoomInImageClick.setAttribute("style", "display: none !important");
            zoomImageOutClick.setAttribute("style", "display: block !important");
        } else {
            counter++;
            addAnalyticsClickZoomImage({
                pdpType,
                zoomEntryPoint,
                zoomAction: "zoom in",
                currentImageData,
                totalImages: pdpImageArrayLength,
                counter,
                resourceType: checkImageResoruceType(currentImageData === null || currentImageData === void 0 ? void 0 : currentImageData.assetId),
                is360Image: false,
                productInfo
            });
            zoomInImageClick.setAttribute("style", "display: block !important");
            zoomImageOutClick.setAttribute("style", "display: none !important");
        }
    };
    const checkImageResoruceType = function() {
        let assetId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if ((productImagesWithUrls === null || productImagesWithUrls === void 0 ? void 0 : productImagesWithUrls.length) > 0) {
            var ref, ref1, ref2;
            return (ref2 = (ref1 = (ref = productImagesWithUrls.filter((img)=>{
                return img.includes(assetId);
            })) === null || ref === void 0 ? void 0 : ref.toString()) === null || ref1 === void 0 ? void 0 : ref1.split("|")) === null || ref2 === void 0 ? void 0 : ref2[2];
        }
    };
    const pdpThumbnailAnyltics = function(element) {
        let i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var ref;
        setActiveIndex(i);
        setThumbnailClicked(true);
        if ((element === null || element === void 0 ? void 0 : element.assetId) || (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0])) {
            var ref1, ref2;
            const resourceType = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceName) === null || ref1 === void 0 ? void 0 : ref1[0]) ? element === null || element === void 0 ? void 0 : (ref2 = element.resourceTypeImg) === null || ref2 === void 0 ? void 0 : ref2[0] : checkImageResoruceType(element === null || element === void 0 ? void 0 : element.assetId);
            addPdpThumbnailAnylticsClick({
                pdpImageInfo: element,
                totalImages: pdpImageArrayLength,
                pdpType,
                currentIndex: i + 1,
                resourceType: resourceType === null || resourceType === void 0 ? void 0 : resourceType.toLowerCase(),
                productInfo
            });
        }
    };
    const render360Image = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pdp-image-reel__image-display",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "s7viewerGallery"
            })
        }, "gallery-zoom-image-360-product");
    };
    (0,react.useEffect)(()=>{
        const timerSpin360PdpGallery = setTimeout(()=>{
            if (resourceName) {
                spin360PdpGallery(resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]);
            }
        }, 100);
        return ()=>{
            clearTimeout(timerSpin360PdpGallery);
        };
    }, [
        resourceName
    ]);
    const renderTotalImages = ()=>{
        return data && pdpCustomImagesArray && totalImages ? pdpCustomImagesArray === null || pdpCustomImagesArray === void 0 ? void 0 : pdpCustomImagesArray.map((element, i)=>{
            var ref, ref1;
            const isVideo = element.type === "video";
            const layerImageResourse = (element === null || element === void 0 ? void 0 : element.layerUrl) || "";
            const resourceImageName = element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0];
            const resourceImgFullWebUrl = element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0];
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                elementid: element.assetId,
                id: i,
                className: "pdp-image-reel__image-list ".concat(resourceImageName && resourceImgFullWebUrl ? "noSwiping swiper-no-swiping" : "", "  "),
                role: "listitem",
                "aria-label": element === null || element === void 0 ? void 0 : element.label,
                onClick: ()=>{
                    return !isVideo ? openImageZoom(element.assetId, i, element === null || element === void 0 ? void 0 : element.label, element, layerImageResourse) : imageZoomMobileVideoClick(element.url, i);
                },
                children: [
                    resourceImageName && resourceImgFullWebUrl ? render360Image() : null,
                    !element.type && !resourceImageName && !resourceImgFullWebUrl ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-image-reel__image-display",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                onError: (e)=>{
                                    return e.target.src = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
                                },
                                src: layerImageResourse ? layerImageResourse : (0,helper/* appendPresetToUrl */.QCk)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                alt: element.label,
                                tabIndex: "0",
                                className: "".concat(i === 0 ? "print" : "no-print")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: tap_image_zoom/* default */.Z === null || tap_image_zoom/* default */.Z === void 0 ? void 0 : tap_image_zoom/* default.src */.Z.src,
                                alt: element.label,
                                tabIndex: "0",
                                className: "tap-image-zoom"
                            })
                        ]
                    }, "gallery-zoom-image-".concat(element.assetId)) : !resourceImgFullWebUrl && !resourceImageName ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-video-wrapper",
                        id: "pdpVideos",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "pdp-video",
                            children: width < 971 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                thumb: true,
                                alt: element.label,
                                videoId: element.url,
                                imageSequence: imageSequence,
                                playThumb: width < largeIpadSize && !isModel,
                                width: "100%",
                                height: "350",
                                getVideoInfo: getVideoInfo,
                                zoomEntryPoint: zoomEntryPoint
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                videoId: element.url,
                                width: "100%",
                                height: "350",
                                index: i + 1,
                                totalPdpImages: pdpImageArrayLength,
                                anyliticsText: "main",
                                zoomEntryPoint: zoomEntryPoint
                            })
                        })
                    }, "gallery-zoom-image-".concat(element.url)) : ""
                ]
            }, "gallery-zoom-image-".concat(i));
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            className: "pdp-image-reel__image-list",
            onClick: ()=>openImageZoom(initialImgUrl),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pdp-image-reel__image-display",
                children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    role: "img",
                    src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                    alt: initialImgAlt,
                    tabIndex: "0",
                    className: "print"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "shimmer-loading__para shimmer height-400"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ImageHeroSection, {
                data: data,
                pdpCustomImagesArray: pdpCustomImagesArray,
                zoomVideoId: zoomVideoId,
                closeZoomImageClick: closeZoomImageClick,
                iframeContainer: iframeContainer,
                currentVideoId: currentVideoId,
                zoomEntryPoint: zoomEntryPoint,
                getVideoInfo: getVideoInfo,
                width: width,
                activeImage: activeImage,
                slickRef: slickRef,
                threeSixtyZoomClick: threeSixtyZoomClick,
                threeSixtyOpen: threeSixtyOpen,
                productInfo: productInfo,
                assetAccountName: assetAccountName,
                appendPresetToUrl: helper/* appendPresetToUrl */.QCk,
                swatchUrl: swatchUrl,
                presetConfigObject: presetConfigObject,
                imageZoomClick: imageZoomClick,
                zoomVideoIcon: zoom_video_icon/* default */.Z,
                pdpDesktopImage: pdpDesktopImage,
                imageZoomVideoClick: imageZoomVideoClick,
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pdp-image-reel ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "full-image-pdp " : "", " "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pdp-thumbnail-vertical ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "hide-slider " : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                onSlideChange: (swiper)=>beforeChangeHandlerFilmStrip(swiper),
                                direction: width >= largeIpadSize ? "vertical" : "horizontal",
                                slideToClickedSlide: true,
                                focusableElements: true,
                                slidesPerView: width >= largeIpadSize ? 6 : "auto",
                                spaceBetween: "15px",
                                freeMode: true,
                                watchSlidesProgress: true,
                                className: "slider-pdp-thumbnail",
                                onSwiper: setThumbsSwiper,
                                keyboard: true,
                                mousewheel: true,
                                modules: [
                                    swiper_esm/* Navigation */.W_,
                                    swiper_esm/* Keyboard */.N1,
                                    swiper_esm/* A11y */.s5,
                                    swiper_esm/* FreeMode */.Rv
                                ],
                                a11y: {
                                    enabled: true
                                },
                                ref: swiperThumbRef,
                                scrollbar: width >= 1024 ? false : {
                                    draggable: true
                                },
                                roundLengths: true,
                                shouldSwiperUpdate: true,
                                children: data && pdpCustomImagesArray && pdpImageArrayLength ? pdpCustomImagesArray.map((element, i)=>{
                                    var ref, ref1, ref2;
                                    const resourcePdpImageName = (element === null || element === void 0 ? void 0 : (ref = element.resourceName) === null || ref === void 0 ? void 0 : ref[0]) || "";
                                    const layerImageResourse = element === null || element === void 0 ? void 0 : element.layerUrl;
                                    const resourcePdpImageUrl = (element === null || element === void 0 ? void 0 : (ref1 = element.resourceFullWebUrl) === null || ref1 === void 0 ? void 0 : ref1[0]) || "";
                                    const resourcePdpImageAlt = (element === null || element === void 0 ? void 0 : (ref2 = element.resourceAltText) === null || ref2 === void 0 ? void 0 : ref2[0]) || "";
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: !element.type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            virtualIndex: i,
                                            className: "image-wrapper ".concat(activeIndex === i ? "imageActiveThumb" : "", " ").concat(resourcePdpImageUrl && resourcePdpImageName ? "overlay-image-360" : ""),
                                            onClick: ()=>pdpThumbnailAnyltics(element, i),
                                            children: resourcePdpImageUrl && resourcePdpImageName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        role: "img",
                                                        src: resourcePdpImageUrl,
                                                        alt: resourcePdpImageAlt,
                                                        width: 60,
                                                        height: 60,
                                                        tabIndex: "0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "zoom-video-icon",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: _360_spin_overlay/* default */.Z === null || _360_spin_overlay/* default */.Z === void 0 ? void 0 : _360_spin_overlay/* default.src */.Z.src,
                                                            alt: "pdp-image",
                                                            tabIndex: "10 ".concat(+i)
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                role: "img",
                                                src: layerImageResourse ? layerImageResourse : (0,helper/* appendPresetToUrl */.QCk)(assetAccountName, swatchUrl, element.assetId, width, presetConfigObject, true),
                                                alt: element === null || element === void 0 ? void 0 : element.label,
                                                width: 60,
                                                height: 60
                                            })
                                        }, "zoom-image-".concat(element === null || element === void 0 ? void 0 : element.assetId)) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* SwiperSlide */.o5, {
                                            onClick: ()=>imageZoomVideoClick(element.url, i),
                                            className: "image-wrapper zoom-video-section".concat(activeIndex === i ? " imageActiveThumb" : "", " "),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper/* default */.Z, {
                                                    thumb: true,
                                                    videoId: element.url,
                                                    getVideoInfo: getVideoInfo,
                                                    index: i,
                                                    tabIndex: "0",
                                                    totalPdpImages: pdpImageArrayLength,
                                                    zoomEntryPoint: zoomEntryPoint
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "zoom-video-icon",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: play_button_overlay/* default */.Z === null || play_button_overlay/* default */.Z === void 0 ? void 0 : play_button_overlay/* default.src */.Z.src,
                                                        alt: "pdp video"
                                                    })
                                                })
                                            ]
                                        }, "zoom-video-".concat(i))
                                    }, "gallery-zoom-image-".concat(i));
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "image-wrapper ",
                                    children: initialImgUrl && pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        role: "button",
                                        src: pdpDesktopImage.replace("/}", "/".concat(initialImgUrl, "}")),
                                        alt: initialImgAlt
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "shimmer-loading__para shimmer height-400"
                                    })
                                })
                            }, "slider-pdp-thumbnail"),
                            pdpImageArrayLength && pdpImageArrayLength > 6 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "image-gallery-view",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "gallery-image-number",
                                    tabIndex: "0",
                                    onClick: ()=>{
                                        return viewGalleryImageClick((layerImageData === null || layerImageData === void 0 ? void 0 : layerImageData.layerUrl) || firstImageForZoom);
                                    },
                                    children: [
                                        "+",
                                        pdpImageArrayLength - 6
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pdp-image-reel__image-stack-view  ".concat(pdpImageArrayLength && pdpImageArrayLength <= 1 ? "full-image-width " : "").concat(width < largeIpadSize ? " pdp-image-reel__slider-container" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "pl-0 list-inline pdp-image-reel__image-stack-list ".concat((resourceName === null || resourceName === void 0 ? void 0 : resourceName[0]) && (resourceFullWebUrl === null || resourceFullWebUrl === void 0 ? void 0 : resourceFullWebUrl[0]) ? "three-sixty-image-pdp-gallery" : ""),
                            role: "list",
                            id: galleryStackId,
                            ref: threeSixtyIframeContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                modules: [
                                    swiper_esm/* Navigation */.W_,
                                    swiper_esm/* Keyboard */.N1,
                                    swiper_esm/* A11y */.s5
                                ],
                                navigation: true,
                                slidesPerView: 1,
                                onSlideChange: (swiper)=>beforeChangeHandler(swiper),
                                thumbs: {
                                    swiper: thumbsSwiper
                                },
                                focusableElements: false,
                                keyboard: true,
                                className: "slider-pdp",
                                a11y: {
                                    enabled: true
                                },
                                ref: swiperPdpRef,
                                children: !initialImgUrl && !pdpDesktopImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__para shimmer height-400"
                                }) : renderTotalImages()
                            }, "pdpSliderKey")
                        })
                    })
                ]
            }),
            resourceCredits ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "pdp-image-reel__photo-credit",
                children: resourceCredits
            }) : null
        ]
    });
};
ImageReel.propTypes = {
    data: prop_types_default().arrayOf((prop_types_default()).any).isRequired,
    staticTexts: (prop_types_default()).object,
    productInfo: (prop_types_default()).array,
    imageClickCounter: (prop_types_default()).number,
    threeSixtyResourceData: (prop_types_default()).object
};
/* harmony default export */ var v3_ImageReel = (ImageReel);

;// CONCATENATED MODULE: ./components/ImageGallery/v3/ImageGallery.jsx




const ImageGallery = (props)=>{
    const [showModal, setShowModal] = (0,react.useState)(null);
    const viewBtnRef = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        (0,helper/* preventBodyScroll */.MVu)(showModal);
        if (showModal) document.body.classList.add("image-gallery-modal-opened");
        else if (showModal === false) {
            document.body.classList.remove("scroll-lock", "image-gallery-modal-opened");
            viewBtnRef.current.focus();
        }
    }, [
        showModal
    ]);
    const handleModalPopup = ()=>{
        setShowModal(true);
    };
    // const isHorizontalView = window?.innerWidth < 1024
    const isHorizontalView = false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ImageReel, {
        viewBtnRef: viewBtnRef,
        isHorizontal: isHorizontalView,
        handlePopup: handleModalPopup,
        galleryStackId: "image-gallery__image-stack-gallery",
        ...props
    });
};
/* harmony default export */ var v3_ImageGallery = (ImageGallery);

// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/ImageGalleryUI.module.scss
var ImageGalleryUI_module = __webpack_require__(53646);
var ImageGalleryUI_module_default = /*#__PURE__*/__webpack_require__.n(ImageGalleryUI_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/ImageGalleryUI.jsx







const ImageGalleryUI = (props)=>{
    const { data =[] , layerImageData ={} , config ={} , productInfoBundle =[]  } = props || {};
    const swatchUrl = constants["default"].COLOR_FILE_URL;
    const { authorData ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { presetConfigs ="{}" , pdpDesktopImage =""  } = authorData !== null && authorData !== void 0 ? authorData : {
        presetConfigs: "{}",
        pdpDesktopImage: ""
    };
    const presetConfigObject = JSON.parse(presetConfigs);
    const { general: { scene7AccountName ="PAWEB"  } = {}  } = config;
    const [initialImgAlt, setInitialImgAlt] = (0,react.useState)("");
    const [initialImgUrl, setInitialImgUrl] = (0,react.useState)("");
    const { label ="" , assetId =""  } = data[0] || {};
    (0,react.useEffect)(()=>{
        if (label && assetId) {
            setInitialImgAlt(label);
            setInitialImgUrl(assetId);
        }
    }, [
        label,
        assetId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ImageGalleryUI_module_default()).ImageGalleryUI,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v3_ImageGallery, {
            data: data,
            presetConfigObject: presetConfigObject,
            swatchUrl: swatchUrl,
            assetAccountName: scene7AccountName,
            initialImgAlt: initialImgAlt,
            initialImgUrl: initialImgUrl,
            layerImageData: layerImageData,
            pdpDesktopImage: pdpDesktopImage,
            productInfo: productInfoBundle
        })
    });
};
/* harmony default export */ var ui_ImageGalleryUI = (/*#__PURE__*/react.memo(ImageGalleryUI));

// EXTERNAL MODULE: ./public/icons/right-arrow.svg
var right_arrow = __webpack_require__(14074);
// EXTERNAL MODULE: ./public/icons/left-arrow.svg
var left_arrow = __webpack_require__(23896);
// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/ProductOptionSelectorUI.module.scss
var ProductOptionSelectorUI_module = __webpack_require__(63811);
var ProductOptionSelectorUI_module_default = /*#__PURE__*/__webpack_require__.n(ProductOptionSelectorUI_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/context/actions/index.js

/**
 * Sets user info and token in the context store
 * @param {Object} payload The user login data
 * @return {Object} The action object with type and payload
 */ const setSwatchColorAction = (payload)=>({
        type: SET_SWATCH_COLOR_NAME,
        payload
    });
/**
 * Action creator for setting selected products data.
 *
 * @param {Object} payload - The data to set for the selected products.
 * @return {Object} The action object containing the type and payload.
 */ const setSelectedProductsAction = (payload)=>({
        type: SET_SELECTED_PRODUCTS_DATA,
        payload
    });
/**
 * Action creator for setting selected products data.
 *
 * @param {Object} payload - The data to set for the selected products.
 * @return {Object} The action object containing the type and payload.
 */ const setInitSelectedProductsAction = (payload)=>({
        type: SET_INIT_SELECTED_PRODUCTS_DATA,
        payload
    });
/**
 * Action creator for setting inventory data.
 *
 * @param {Object} payload - The data to be set in the inventory.
 * @return {Object} The action object containing the type and payload.
 */ const setInventoryDataAction = (payload)=>({
        type: SET_INVENTORY_DATA,
        payload
    });
/**
 * Creates an action to set the inventory status.
 *
 * @param {Boolean} payload - The data to update the inventory status with.
 * @return {Boolean} The action object with type and payload.
 */ const setInventoryStatusAction = (payload)=>({
        type: SET_INVENTORY_STATUS,
        payload
    });
/**
 * Action creator for setting projection data.
 *
 * @param {Object} payload - The data to be set in the projection.
 * @return {Object} The action object containing the type and payload.
 */ const setProjectionDataAction = (payload)=>({
        type: SET_PROJECTION_DATA,
        payload
    });

// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
// EXTERNAL MODULE: ./components/Shared/QuickView/utlis.js
var utlis = __webpack_require__(55888);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/ProductOptionSelectorSwiperSlideUI.jsx





const ProductOptionSelectorSwiperSlideUI = (props)=>{
    const { swatchName ="" , product ={} , staticTexts ={} , openPdpQuickViewModal =()=>{} , handleSelectItem =()=>{} , variantSku ="" , setTriggerAnalyticsOnProductClick =()=>{} , optionCategory =""  } = props || {};
    const { masterSku , colorDetails , imageDetails  } = product;
    const { outOfStockText ="" , quickViewLabel =""  } = staticTexts;
    const { state  } = useStore();
    const { inventory =[] , inventoryStatus =false , projectionData =[]  } = state;
    const { imageUrl ="" , sku: productSku = "" , customerFacingSku =""  } = getSelectedColorImage({
        colorDetails,
        imageDetails,
        swatchName
    });
    const isInventory = isAvailableInventory({
        inventory,
        sku: productSku
    });
    const isBackorderable = isSkuBackOrderable({
        data: projectionData,
        sku: productSku
    });
    const isSelected = productSku === variantSku;
    const onProductClick = ()=>{
        handleSelectItem({
            masterSku,
            sku: productSku,
            isInventory: isInventory,
            customerFacingSku
        });
        setTriggerAnalyticsOnProductClick({
            sku: productSku,
            optionCategory
        });
    };
    const quickViewEnable = !inventoryStatus || isInventory || isBackorderable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "option",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                width: 150,
                height: 150,
                src: imageUrl,
                alt: masterSku,
                loading: "eager",
                onClick: onProductClick,
                className: "product-option-image ".concat(isSelected ? "selected" : ""),
                tabIndex: 0
            }),
            quickViewEnable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "quick-view-button",
                onClick: ()=>openPdpQuickViewModal(product, productSku),
                tabIndex: 0,
                children: quickViewLabel
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "out-of-stock",
                children: outOfStockText
            })
        ]
    });
};
/* harmony default export */ var ui_ProductOptionSelectorSwiperSlideUI = (ProductOptionSelectorSwiperSlideUI);

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/analytics/constants.js
const ADD_TO_CART = "add to cart";
const COLOR_SELECTION = "color selection";
const INCLUDE_SELECT = "include select ";
const SILDER_BUNDLE_IMAGE_CLICK = "slider bundle image click";
const PDP = "pdp";
const PRODUCT_DETAILS = "product details";
const BUNDLE = "bundle";
const SPECS = "specs";
const VIEW_MORE = "view more";
const MOUSEOVER = "mouseover";
const ACCORDIAN = "accordion";
const PRINT = "print";
const SHARE = "share";
const BREADCRUMB = "breadcrumb";
const STICKY_NAV = "sticky nav";
const HEADER = "header";

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/analytics/index.js


const loadCmpShowEvent = (data)=>{
    var ref, ref1, ref2, ref3;
    const { productInfoBundle: productInfo = [] , siteName ="kohler" , category ="" , sku ="" , cmpShowAnlyticsTimer =null  } = data;
    const initialColor = (productInfo === null || productInfo === void 0 ? void 0 : (ref = productInfo[0]) === null || ref === void 0 ? void 0 : ref.bundleProductColors) || "";
    const initialPrice = (productInfo === null || productInfo === void 0 ? void 0 : (ref1 = productInfo[0]) === null || ref1 === void 0 ? void 0 : ref1.bundlePrice) || 0;
    if (!productInfo || productInfo.length === 0 || !initialColor || initialPrice === 0) {
        return null;
    }
    const categoryName = (0,helper/* sanitizeTextForAnalytics */.T68)(category);
    const fullSku = (0,helper/* sanitizeTextForAnalytics */.T68)("K-" + sku);
    const page = window.pageObj || {};
    const pageCategory = ((ref2 = window.pageObj) === null || ref2 === void 0 ? void 0 : ref2.category) || {};
    const pageType = (pageCategory === null || pageCategory === void 0 ? void 0 : pageCategory.pageType) || "";
    pageCategory["productLocalCategory"] = categoryName;
    pageCategory["room"] = "n/a" // TODO: need to get the primary category, no data available in the api response
    ;
    pageCategory["subCategory1"] = pageType + ":" + categoryName;
    pageCategory["subCategory2"] = pageType + ":" + categoryName + ":" + fullSku;
    pageCategory["subCategoryID"] = fullSku;
    pageCategory["subCategoryName"] = categoryName;
    const { pageInfo: { contentType ="pdp"  } = {}  } = page;
    const pageInfo = ((ref3 = window.pageObj) === null || ref3 === void 0 ? void 0 : ref3.pageInfo) || {};
    pageInfo["pageName"] = (0,helper/* sanitizeTextForAnalytics */.T68)("".concat(siteName, ":").concat(contentType || "pdp", ":").concat(categoryName, ":").concat(fullSku));
    pageInfo["imageId"] = "n/a";
    pageInfo["resourceType"] = "imgitemiso";
    pageInfo["defaultImage"] = "n/a";
    pageInfo["title"] = (0,helper/* sanitizeTextForAnalytics */.T68)(pageInfo["title"]);
    page.category = pageCategory;
    page.user = (0,helper/* getUserAnalyticsObject */.L7i)();
    page.productInfo = [
        ...productInfo
    ];
    if (window === null || window === void 0 ? void 0 : window.needPdpdata) {
        delete window.needPdpdata;
    }
    if ((!page.user.gId || page.user.gId === "n/a") && (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")) {
        page.pageInfo = pageInfo;
        window.pageObj = page;
        window.isShowAnalyticsEvent = true;
    } else {
        window.adobeDataLayer.push({
            event: "cmp:show",
            pageInfo,
            productInfo,
            page
        });
        clearInterval(cmpShowAnlyticsTimer);
    }
};
const bundleAddToCartAnalytics = (productInfo)=>{
    const eventInfo = {
        eventAction: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "".concat(PDP, ":").concat(BUNDLE),
        internalLinkType: "".concat(PDP, ":").concat(ADD_TO_CART),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PDP, ":").concat(PRODUCT_DETAILS),
        modalName: BUNDLE
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const colorSelectorAnalytics = (productInfo)=>{
    const eventInfo = {
        eventAction: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(COLOR_SELECTION),
        eventMsg: "n/a",
        eventName: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(COLOR_SELECTION),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: COLOR_SELECTION,
        internalLinkPosition: "".concat(PDP, ":").concat(BUNDLE),
        internalLinkType: "".concat(PDP, ":").concat(COLOR_SELECTION),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PDP, ":").concat(PRODUCT_DETAILS),
        modalName: BUNDLE
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const productOptionSelectorAnalytics = (productInfo, optionCategory)=>{
    const eventInfo = {
        eventAction: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(optionCategory),
        eventMsg: "n/a",
        eventName: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(optionCategory),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: optionCategory,
        internalLinkPosition: "".concat(PDP, ":").concat(BUNDLE),
        internalLinkType: "".concat(PDP, ":product selection"),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PDP, ":").concat(PRODUCT_DETAILS),
        modalName: BUNDLE
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, [
        productInfo
    ]);
};
const selectedProductListAnalytics = (productInfo, accordianAction)=>{
    const eventInfo = {
        eventAction: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(INCLUDE_SELECT).concat(accordianAction),
        eventMsg: "n/a",
        eventName: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(INCLUDE_SELECT).concat(accordianAction),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(INCLUDE_SELECT).concat(accordianAction),
        internalLinkPosition: "".concat(PDP, ":").concat(BUNDLE),
        internalLinkType: "".concat(PDP, ":").concat(INCLUDE_SELECT).concat(accordianAction),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PDP, ":").concat(PRODUCT_DETAILS),
        modalName: BUNDLE
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const navigationAnalytics = (productInfo, slideDirection)=>{
    const eventInfo = {
        eventAction: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(SILDER_BUNDLE_IMAGE_CLICK, ":").concat(slideDirection),
        eventMsg: "n/a",
        eventName: "".concat(PDP, ":").concat(PRODUCT_DETAILS, ":").concat(SILDER_BUNDLE_IMAGE_CLICK, ":").concat(slideDirection),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "".concat(slideDirection, " arrow"),
        internalLinkPosition: "".concat(PDP, ":").concat(BUNDLE),
        internalLinkType: "".concat(PDP, ":").concat(slideDirection, " arrow"),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(PDP, ":").concat(PRODUCT_DETAILS),
        modalName: BUNDLE
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const bundleAddToCartFromStickyAnalytics = (productInfo)=>{
    const eventInfo = {
        eventAction: "pdp:".concat(STICKY_NAV, ":").concat(ADD_TO_CART),
        eventMsg: "n/a",
        eventName: "pdp:".concat(STICKY_NAV, ":").concat(ADD_TO_CART),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: ADD_TO_CART,
        internalLinkPosition: "pdp:bundle:".concat(HEADER),
        internalLinkType: "pdp:".concat(ADD_TO_CART),
        clickInternalLinks: "true",
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(STICKY_NAV),
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const accordianClickBundleFeature = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", accordianState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", productInfoBundle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const eventInfo = {
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(ACCORDIAN, " ").concat(accordianState),
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(ACCORDIAN, " ").concat(accordianState),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: accordianState,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(title),
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle);
};
const viewMoreBundleFeature = function() {
    let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", productInfoBundle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const eventInfo = {
        eventAction: "pdp:".concat(SPECS, ":").concat(VIEW_MORE),
        eventName: "pdp:".concat(SPECS, ":").concat(VIEW_MORE),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(VIEW_MORE),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(SPECS, ":").concat(VIEW_MORE),
        internalLinkZoneName: "pdp:".concat(SPECS),
        internalLinkURL: "".concat(window.location.origin).concat(url),
        clickInternalLinks: "true",
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle);
};
const dimensionsTooltipAnalyticsData = function() {
    let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", productInfoBundle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const title = type.toLowerCase().trim();
    const eventInfo = {
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(title, " ").concat(MOUSEOVER),
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(title, " ").concat(MOUSEOVER),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: message === null || message === void 0 ? void 0 : message.toLocaleLowerCase(),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(MOUSEOVER, ":").concat(title),
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        internalLinkURL: "n/a",
        clickInternalLinks: "true",
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle);
};
const addAnlyticsForSDownloadSpec = function() {
    let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedFileList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], techFils = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], mainTitle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", productInfoBundle = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    const techFilsLists = techFils.map((selectedObj)=>selectedObj.toLowerCase());
    const eventInfo = {
        eventAction: "pdp:".concat(mainTitle, ":").concat(title),
        eventName: "pdp:".concat(mainTitle, ":").concat(title),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "success",
        internalLinkName: "".concat(title, "|").concat(selectedFileList.join(":").toLowerCase()),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(mainTitle, ":").concat(title),
        internalLinkZoneName: "pdp:".concat(mainTitle),
        internalLinkURL: techFilsLists.join(":"),
        clickInternalLinks: "true",
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle);
};
const bundleBreadCrumbPrintAnalytics = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(PRINT),
        eventMsg: "n/a",
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(PRINT),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: PRINT,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(PRINT),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const bundleBreadCrumbShareAnalytics = (productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventMsg: "n/a",
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: SHARE,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(SHARE),
        internalLinkURL: "n/a",
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const bundleBreadCrumbEmailAndCopyLinkAnalytics = (param)=>{
    let { productInfo =[] , link =""  } = param;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventMsg: "n/a",
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventStatus: "n/a",
        eventType: "informative",
        internalLinkName: link ? "copy link" : "email a friend",
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(SHARE),
        internalLinkURL: link || "n/a",
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const bundleBreadSocialShareAnalytics = (param)=>{
    let { productInfo =[] , link ="" , hostname =""  } = param;
    let linkName = "";
    if (hostname.includes("pinterest")) {
        linkName = "pinterest";
    } else if (hostname.includes("facebook")) {
        linkName = "facebook";
    } else if (hostname.includes("x.com")) {
        linkName = "x";
    } else if (hostname.includes("linkedin")) {
        linkName = "linkedin";
    }
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventMsg: "n/a",
        eventName: "pdp:".concat(PRODUCT_DETAILS, ":").concat(SHARE),
        eventStatus: "n/a",
        eventType: "informative",
        internalLinkName: linkName,
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(SHARE),
        internalLinkURL: link || "n/a",
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfo);
};
const bundleBreadCrumbAnalytics = (param)=>{
    let { internalLinkName ="" , link ="" , productInfoBundle =[]  } = param;
    var ref;
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "pdp:".concat(BREADCRUMB),
        eventName: "pdp:".concat(BREADCRUMB),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: (0,helper/* sanitizeTextForAnalytics */.T68)(internalLinkName),
        internalLinkPosition: "pdp:bundle",
        internalLinkType: "pdp:".concat(BREADCRUMB),
        internalLinkZoneName: "pdp:".concat(PRODUCT_DETAILS),
        internalLinkURL: link ? (((ref = String(link)) === null || ref === void 0 ? void 0 : ref.indexOf("http")) === -1 ? window.location.origin : "") + link : "n/a",
        modalName: "bundle"
    };
    analytics_pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle);
};
const analytics_pushAnalyticsObjToDataLayer = function() {
    let eventInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, productInfo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const event = "cmp:click";
    let eventData = {
        event,
        eventInfo,
        page
    };
    if ((productInfo === null || productInfo === void 0 ? void 0 : productInfo.length) > 0) {
        eventData = {
            ...eventData,
            productInfo: productInfo
        };
    }
    window.adobeDataLayer.push(eventData);
};

// EXTERNAL MODULE: ./components/Shared/QuickView/analytics.js
var analytics = __webpack_require__(78592);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/analytics/getProductInfo.js


const getProductInfo = (param)=>{
    let { data ={} , skusPrice =[] , siteName ="" , swatchName =""  } = param;
    const { pdpDetails ={} , inventory =[] , selectedProducts =[] , bundleItems =[] , projectionData =[] , imageGallery: { bundleListImages =[]  } = {}  } = data;
    const selectedSkus = selectedProducts.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.sku;
    });
    const selectedSkusDetails = getSelectedImageGallaryDetails(bundleListImages, selectedSkus);
    const selectedImageDetails = selectedSkus.map((sku, index)=>{
        return getImageGalleryData(selectedSkusDetails[index], sku);
    });
    const { intialimages  } = getAllImage(selectedSkusDetails, selectedImageDetails);
    const bundlePrice = skusPrice.reduce((acc, item)=>{
        const { priceProduct =0 , discountPrice =0  } = item || {};
        const price = discountPrice > 0 ? discountPrice : priceProduct;
        const finalPrice = Number(price) || 0;
        return acc + finalPrice;
    }, 0);
    const { sku: bundleSku = ""  } = pdpDetails;
    const pData = getSelectedbundleDetails({
        selectedSkus: selectedSkus,
        data: bundleItems
    });
    const productInfodata = skusPrice.map((each, index)=>{
        var ref;
        const { sku ="" , priceProduct =0 , discountPrice =0  } = each || {};
        const productSkuKey = sku === null || sku === void 0 ? void 0 : sku.split("-").slice(0, -1).join("-");
        const eachProduct = pData.find((item)=>item.sku.includes(productSkuKey)) || {};
        const { title ="" , primaryCategory ="" , category: localcategory = "" , productBrandName ="" , productName ="" , regionBrandName ="" , productWaterSense =false  } = eachProduct || {};
        const primaryCategoryS = (0,helper/* sanitizeTextForAnalytics */.T68)(primaryCategory);
        const productBrandNameS = (0,helper/* sanitizeTextForAnalytics */.T68)(productBrandName);
        const price = Number(priceProduct) || 0;
        const discount = Number(discountPrice) || 0;
        const commonProductInfo = {
            bundleIds: "K-".concat(bundleSku),
            bundleProductColors: (0,helper/* sanitizeTextForAnalytics */.T68)(swatchName),
            bundlePrice: Number(bundlePrice.toFixed(2)),
            pdpType: "bundle"
        };
        const { availableQuantity =0  } = inventory.find((item)=>item.sku === sku) || {};
        const isBackOrder = isSkuBackOrderable({
            data: projectionData,
            sku: sku
        });
        const productStatus = availableQuantity > 0 ? "in stock" : isBackOrder ? "back order" : "out of stock";
        const eachProductInfodata = {
            category: primaryCategoryS || "n/a",
            description: (0,helper/* sanitizeTextForAnalytics */.T68)(title) || "n/a",
            defaultImageName: ((ref = intialimages[index]) === null || ref === void 0 ? void 0 : ref.url) || "n/a",
            frequency: "n/a",
            globalDiscount: discount || 0,
            globalOffer: "n/a",
            globalPromotionPrice: price || 0,
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            itemType: primaryCategoryS || "n/a",
            numberOfReviews: "n/a",
            priceState: "regular price",
            productBasePrice: priceProduct || 0,
            productBrand: (0,helper/* sanitizeTextForAnalytics */.T68)(siteName),
            productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(localcategory) || "n/a",
            productCollectionsName: productBrandNameS || "n/a",
            productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(swatchName),
            productCouponCode: "n/a",
            productCoupondiscount: 0,
            productFindingMethod: "n/a",
            productID: "K-".concat(sku),
            productName: productBrandNameS || (0,helper/* sanitizeTextForAnalytics */.T68)(regionBrandName || productName) || "n/a",
            productPartnerBuyNow: "false",
            productRoom: primaryCategoryS || "n/a",
            productSalePrice: discountPrice > 0 ? Number((discount - 0).toFixed(2)) : price,
            productSaleable: true,
            productStatus: productStatus,
            productSuperSku: false,
            productTileName: productBrandNameS || "n/a",
            quantity: 1,
            ratings: "n/a",
            waterSenseProduct: productWaterSense ? "true" : "false"
        };
        return {
            ...commonProductInfo,
            ...eachProductInfodata
        };
    });
    return productInfodata;
};
const getProductInfoForAnalytics = (data)=>{
    var ref;
    const { productName , sku , category , title , siteName , productBrandName , swatchName , productWaterSense =[] , inventory =[] , projectionData =[] , regionBrandName ="" , persona , currencyCode ="" , bundleListImages =[]  } = data;
    const categoryS = (0,helper/* sanitizeTextForAnalytics */.T68)(category);
    const productBrandNameS = (0,helper/* sanitizeTextForAnalytics */.T68)(productBrandName);
    const { availableQuantity =0  } = inventory.find((item)=>item.sku === sku) || {};
    const isBackOrder = isSkuBackOrderable({
        data: projectionData,
        sku: sku
    });
    const productStatus = availableQuantity > 0 ? "in stock" : isBackOrder ? "back order" : "out of stock";
    const skuPrice = getSelectedProductPrices({
        productLists: projectionData,
        skus: [
            sku
        ],
        currencyCode,
        persona
    });
    const { priceProduct =0 , discountPrice =0  } = skuPrice[0] || {};
    const price = Number(priceProduct) || 0;
    const discount = Number(discountPrice) || 0;
    const imageGalleryDetails = getSelectedImageGallaryDetails(bundleListImages, [
        sku
    ]);
    const imageDetails = getImageGalleryData(imageGalleryDetails[0], sku);
    const { intialimages  } = getAllImage(imageGalleryDetails, [
        imageDetails
    ]);
    const productInfo = {
        category: categoryS || "n/a",
        description: (0,helper/* sanitizeTextForAnalytics */.T68)(title) || "n/a",
        defaultImageName: ((ref = intialimages[0]) === null || ref === void 0 ? void 0 : ref.url) || "n/a",
        frequency: "n/a",
        globalDiscount: discount || 0,
        globalOffer: "n/a",
        globalPromotionPrice: price || 0,
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        itemType: categoryS || "n/a",
        numberOfReviews: "n/a",
        priceState: "regular price",
        productBasePrice: priceProduct || 0,
        productBrand: (0,helper/* sanitizeTextForAnalytics */.T68)(siteName),
        productCategory: categoryS || "n/a",
        productCollectionsName: productBrandNameS || "n/a",
        productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(swatchName),
        productCouponCode: "n/a",
        productCoupondiscount: 0,
        productFindingMethod: "n/a",
        productID: "K-".concat(sku),
        productName: productBrandNameS || (0,helper/* sanitizeTextForAnalytics */.T68)(regionBrandName || productName) || "n/a",
        productPartnerBuyNow: "false",
        productRoom: categoryS || "n/a",
        productSalePrice: discountPrice > 0 ? Number((discount - 0).toFixed(2)) : price,
        productSaleable: true,
        productStatus: productStatus,
        productSuperSku: false,
        productTileName: productBrandNameS || "n/a",
        quantity: 1,
        ratings: "n/a",
        waterSenseProduct: productWaterSense[0] === "Yes" ? "true" : "false"
    };
    return productInfo;
};

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/ProductOptionSelectorUI.jsx











const QuickView = dynamic_default()(()=>__webpack_require__.e(/* import() */ 322).then(__webpack_require__.bind(__webpack_require__, 10322)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10322)
            ]
    }
});







const ProductOptionSelectorUI = (props)=>{
    var ref, ref1, ref2, ref3;
    const { data: { products: productsList = [] , name =""  } = {} , prevButtonRef =null , nextButtonRef =null , isPrevVisible =false , isNextVisible =false , setIsNextVisible =()=>{} , setIsPrevVisible =()=>{} , isAllSlidesVisible =false , updateButtonVisibility =()=>{} , staticTexts ={} , index =0 , quickViewAuthData ={} , swatchName , selectedProducts =[] , productInfoBundle =[] , config ={} , setTriggerAnalyticsOnProductClick =()=>{}  } = props || {};
    const { state , dispatch  } = useStore();
    const { projectionData =[] , inventory =[] , imageGallery: { bundleListImages =[]  } = {}  } = state;
    const { general: { siteName ="kohler"  } = {} , internationalization: { currencyCode ="USD"  } = {}  } = config;
    const [showQuickViewModal, setShowQuickViewModal] = (0,react.useState)(false);
    const [quickViewProductData, setQuickViewProductData] = (0,react.useState)([]);
    const [quickViewSelectedSku, setQuickViewSelectedSku] = (0,react.useState)("");
    const [productInfo, setProductInfo] = (0,react.useState)({});
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const commonProductInfo = {
        bundleIds: (ref = productInfoBundle[0]) === null || ref === void 0 ? void 0 : ref.bundleIds,
        bundlePrice: (ref1 = productInfoBundle[0]) === null || ref1 === void 0 ? void 0 : ref1.bundlePrice,
        bundleProductColors: (ref2 = productInfoBundle[0]) === null || ref2 === void 0 ? void 0 : ref2.bundleProductColors,
        pdpType: (ref3 = productInfoBundle[0]) === null || ref3 === void 0 ? void 0 : ref3.pdpType
    };
    const handleProductInfo = (data)=>{
        setProductInfo({
            ...data,
            ...commonProductInfo
        });
    };
    const optionCategory = (name === null || name === void 0 ? void 0 : name.replace(/^\d+\.\s*/, "").toLowerCase()) || "";
    const openPdpQuickViewModal = (QuickViewProductData, quickViewSelectedSku)=>{
        const { slug , title  } = QuickViewProductData || {};
        const quickViewData = {
            slug_s: slug,
            RegionBrandName_s: title,
            title_s: title,
            sku_s: quickViewSelectedSku
        };
        setQuickViewSelectedSku(quickViewSelectedSku);
        setQuickViewProductData(quickViewData);
        setShowQuickViewModal(true);
        const persona = (0,helper/* getUserPersona */.shu)();
        const productDataForAnalytics = getProductInfoForAnalytics({
            ...QuickViewProductData,
            siteName,
            swatchName,
            inventory,
            projectionData,
            currencyCode,
            bundleListImages,
            persona,
            sku: quickViewSelectedSku
        });
        (0,analytics/* quickViewOpenAnalytics */.E$)({
            isMultifinishBundle: true,
            productData: productDataForAnalytics,
            optionCategory,
            commonProductInfo
        });
    };
    const closeQuickViewModal = ()=>{
        setShowQuickViewModal(false);
        (0,utlis/* preventPopupScroll */.qt)(true);
    };
    const handleButtonClosed = ()=>{
        (0,analytics/* quickViewCloseAnalytics */.I4)({
            isMultifinishBundle: true,
            productInfo: [
                productInfo
            ],
            optionCategory
        });
    };
    swiper_esm/* default.use */.ZP.use([
        swiper_esm/* Keyboard */.N1,
        swiper_esm/* A11y */.s5,
        swiper_esm/* FreeMode */.Rv
    ]);
    const handleSelectItem = (data)=>{
        dispatch(setSelectedProductsAction({
            id: index,
            name,
            swatchName,
            ...data
        }));
    };
    const products = productsList.filter((item)=>{
        const findItem = item.colorDetails.some((e)=>e.name === swatchName);
        return findItem && item;
    });
    const { masterSku , sku: variantSku  } = selectedProducts[index] || {};
    const { title , colorDetails =[]  } = products.find((product)=>product.masterSku === masterSku) || {};
    const { customerFacingSku =""  } = colorDetails.find((item)=>item.sku === variantSku) || {};
    (0,react.useEffect)(()=>{
        if (showQuickViewModal) {
            (0,utlis/* preventPopupScroll */.qt)();
        }
    }, [
        showQuickViewModal
    ]);
    (0,react.useEffect)(()=>{
        const loadingTimer = setTimeout(()=>{
            setIsLoading(false);
        }, 100);
        return ()=>clearTimeout(loadingTimer);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductOptionSelectorUI_module_default()).ProductOptionSelectorUIWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "user-action",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "product-description",
                        children: [
                            customerFacingSku,
                            ", ",
                            title
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "swiper-container-wrapper ".concat(isLoading ? "is-loading" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            className: "swiper-container",
                            modules: [
                                swiper_esm/* Navigation */.W_,
                                swiper_esm/* Keyboard */.N1,
                                swiper_esm/* A11y */.s5,
                                swiper_esm/* FreeMode */.Rv
                            ],
                            spaceBetween: "20px",
                            slidesPerView: "auto",
                            navigation: {
                                nextEl: nextButtonRef.current,
                                prevEl: prevButtonRef.current
                            },
                            onBeforeInit: (swiper)=>{
                                swiper.params.navigation.prevEl = prevButtonRef.current;
                                swiper.params.navigation.nextEl = nextButtonRef.current;
                            },
                            onSlideChange: updateButtonVisibility,
                            onSetTranslate: (swiper)=>updateButtonVisibility(swiper),
                            onInit: (swiper)=>{
                                updateButtonVisibility(swiper);
                                setIsLoading(false);
                            },
                            onReachEnd: ()=>setIsNextVisible(false),
                            onReachBeginning: ()=>setIsPrevVisible(false),
                            allowTouchMove: true,
                            touchStartPreventDefault: false,
                            simulateTouch: true,
                            freeMode: true,
                            draggable: true,
                            children: [
                                products.map((product, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductOptionSelectorSwiperSlideUI, {
                                            swatchName: swatchName,
                                            product: product,
                                            staticTexts: staticTexts,
                                            openPdpQuickViewModal: openPdpQuickViewModal,
                                            handleSelectItem: handleSelectItem,
                                            variantSku: variantSku,
                                            setTriggerAnalyticsOnProductClick: setTriggerAnalyticsOnProductClick,
                                            optionCategory: optionCategory
                                        })
                                    }, product.sku);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "caraousal-button-container ".concat(isAllSlidesVisible ? "all-slides-visible" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: left_arrow/* default.src */.Z.src,
                                            className: "custom-prev-button ".concat(!isPrevVisible ? "hidden" : ""),
                                            alt: "custom-prev-button",
                                            ref: prevButtonRef,
                                            onClick: ()=>navigationAnalytics(productInfoBundle, "left")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: right_arrow/* default.src */.Z.src,
                                            className: "custom-next-button ".concat(!isNextVisible ? "hidden" : ""),
                                            alt: "custom-next-button",
                                            ref: nextButtonRef,
                                            onClick: ()=>navigationAnalytics(productInfoBundle, "right")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                showModal: showQuickViewModal,
                onModalClose: closeQuickViewModal,
                isCloseButtonClicked: handleButtonClosed,
                className: "quickview-modal",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
                    productData: quickViewProductData,
                    authorData: quickViewAuthData,
                    closeModal: closeQuickViewModal,
                    isMultifinishBundle: true,
                    quickViewSelectedSku: quickViewSelectedSku,
                    productOptionCategory: optionCategory,
                    productInfoBundle: productInfoBundle,
                    handleProductInfo: handleProductInfo
                })
            })
        ]
    });
};
/* harmony default export */ var ui_ProductOptionSelectorUI = (ProductOptionSelectorUI);

// EXTERNAL MODULE: ./components/Bundles/localization.js
var localization = __webpack_require__(60303);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ProductOptionSelector.jsx





const ProductOptionSelector = (props)=>{
    const { authoredData ={} , config ={}  } = props || {};
    const prevButtonRef = (0,react.useRef)(null);
    const nextButtonRef = (0,react.useRef)(null);
    const [isPrevVisible, setIsPrevVisible] = (0,react.useState)(false);
    const [isNextVisible, setIsNextVisible] = (0,react.useState)(false);
    const [isAllSlidesVisible, setIsAllSlidesVisible] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    const { general: { swatchUrl ="" , scene7AccountName ="PAWEB"  } = {}  } = config || {};
    const { presetConfigs ="{}"  } = authoredData;
    // To update the visibility of the next and previous buttons based on the current slide position
    const updateButtonVisibility = (swiper)=>{
        var ref;
        const slideWidth = ((ref = swiper.slides[0]) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
        const slidesCount = swiper.slides.length;
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.endsWith("px")) {
            spaceBetween = parseInt(spaceBetween, 10);
        } else {
            spaceBetween = Number(spaceBetween) || 0;
        }
        const totalSlidesWidth = slideWidth * slidesCount + spaceBetween * (slidesCount - 1);
        const allSlidesVisible = totalSlidesWidth <= swiper.width;
        setIsAllSlidesVisible(allSlidesVisible);
        if (allSlidesVisible) {
            setIsPrevVisible(false);
            setIsNextVisible(false);
        } else {
            setIsPrevVisible(!swiper.isBeginning);
            setIsNextVisible(!swiper.isEnd);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-option-selector",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductOptionSelectorUI, {
            ...props,
            prevButtonRef: prevButtonRef,
            nextButtonRef: nextButtonRef,
            isPrevVisible: isPrevVisible,
            isNextVisible: isNextVisible,
            setIsNextVisible: setIsNextVisible,
            setIsPrevVisible: setIsPrevVisible,
            isAllSlidesVisible: isAllSlidesVisible,
            updateButtonVisibility: updateButtonVisibility,
            staticTexts: staticTexts,
            presetConfigObject: JSON.parse(presetConfigs),
            assetAccountName: scene7AccountName,
            swatchUrl: swatchUrl
        })
    });
};
/* harmony default export */ var MultiFinshProductBundle_ProductOptionSelector = (ProductOptionSelector);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductAccordionList/utils.js
var ProductAccordionList_utils = __webpack_require__(4464);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.module.scss
var Accordion_module = __webpack_require__(96724);
var Accordion_module_default = /*#__PURE__*/__webpack_require__.n(Accordion_module);
// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/BundleDetailsAccordianUI.module.scss
var BundleDetailsAccordianUI_module = __webpack_require__(69503);
var BundleDetailsAccordianUI_module_default = /*#__PURE__*/__webpack_require__.n(BundleDetailsAccordianUI_module);
// EXTERNAL MODULE: ./node_modules/react-collapsible/dist/index.js
var dist = __webpack_require__(97893);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader/index.js
var CollapsibleHeader = __webpack_require__(98791);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/BundleSpecsInstallationUI.jsx












const BundleSpecsInstallationUI = (props)=>{
    const { label ="" , specFiles =[] , installGuidesFiles =[] , isOpen =false , sku ="" , productInfoBundle ={}  } = props || {};
    const [isDisabledSpec, setIsDisabledSpec] = (0,react.useState)(false);
    const [isDisabledInstall, setIsDisabledInstall] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { specsInstallationLabel ="" , downloadAllSpecSheetsLabel ="" , downloadAllInstallGuidesLabel =""  } = (0,localization/* getTranslations */.F)(t);
    const handleDownloadSpecZip = async function() {
        let downloadAllSpecSheetsLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mainTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        try {
            const selectedFileList = [];
            specFiles.forEach((selectedObj)=>{
                const techFileInfo = selectedObj.substring(selectedObj.lastIndexOf("/") + 1);
                selectedFileList.push(techFileInfo);
            });
            addAnlyticsForSDownloadSpec(downloadAllSpecSheetsLabel, selectedFileList, specFiles, mainTitle, productInfoBundle);
            await (0,helper/* handleZipDownload */.G12)(specFiles, sku);
            setIsDisabledSpec(false);
        } catch (e) {
            setIsDisabledSpec(false);
        }
    };
    const handleDownloadInstallGuidesZip = async function() {
        let downloadAllSpecSheetsLabel = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", mainTitle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
        setIsDisabledInstall(true);
        try {
            const selectedFileList = [];
            installGuidesFiles.forEach((selectedObj)=>{
                const techFileInfo = selectedObj.substring(selectedObj.lastIndexOf("/") + 1);
                selectedFileList.push(techFileInfo);
            });
            addAnlyticsForSDownloadSpec(downloadAllSpecSheetsLabel, selectedFileList, installGuidesFiles, mainTitle, productInfoBundle);
            await (0,helper/* handleZipDownload */.G12)(installGuidesFiles, sku);
            setIsDisabledInstall(false);
        } catch (e) {
            setIsDisabledInstall(false);
        }
    };
    const handleOpenAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "expand", productInfoBundle);
    };
    const handleCloseAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "collapse", productInfoBundle);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((BundleDetailsAccordianUI_module_default()).BundlesDetailsAccordianUI, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collapsible-accordion bundle-accordian-section ".concat(label.toLowerCase()),
            "data-testid": "bundle-product-accordion-".concat(label),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader/* default */.Z, {
                    title: label
                }),
                triggerOpenedClassName: "collapsible__trigger--open",
                onTriggerOpening: ()=>handleOpenAccordian(label),
                onTriggerClosing: ()=>handleCloseAccordian(label),
                open: false,
                openedClassName: "collapsible--open",
                transitionTime: 400,
                tabIndex: "0",
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: (specFiles.length || installGuidesFiles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row no-gutters px-0",
                    "data-testid": "colapse-data-".concat(specsInstallationLabel),
                    "aria-disabled": isOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 bundles-accordian-button",
                        children: [
                            specFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "ghost",
                                role: "button",
                                label: downloadAllSpecSheetsLabel,
                                onClick: ()=>handleDownloadSpecZip(downloadAllSpecSheetsLabel.toLowerCase(), specsInstallationLabel.toLowerCase()),
                                disabled: isDisabledSpec,
                                loading: isDisabledSpec
                            }) : null,
                            installGuidesFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "ghost",
                                role: "button",
                                label: downloadAllInstallGuidesLabel,
                                onClick: ()=>handleDownloadInstallGuidesZip(downloadAllInstallGuidesLabel.toLowerCase(), specsInstallationLabel.toLowerCase()),
                                disabled: isDisabledInstall,
                                loading: isDisabledInstall
                            }) : null
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var ui_BundleSpecsInstallationUI = (BundleSpecsInstallationUI);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/BundleFeaturesUI.jsx












const BundleFeaturesUI = (props)=>{
    const { data =[] , label ="" , productInfoBundle ={}  } = props || {};
    const getViewMoreLink = (category, slug, sku)=>{
        if (category && slug && sku) {
            const pdpUrl = (0,helper/* getPdpUrlPath */.VvO)(category, slug);
            const param = sku ? "skuId=".concat(sku) : "";
            return (0,utils/* getPdpRedirectUrl */.Om)(pdpUrl, param) || "";
        } else return "";
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { viewMoreLabel =""  } = (0,localization/* getTranslations */.F)(t);
    const getProductBadgeInfo = (icon)=>{
        const watersenseList = icon.split("|");
        return watersenseList[2] || [];
    };
    const handleOpenAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "expand", productInfoBundle);
    };
    const handleCloseAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "collapse", productInfoBundle);
    };
    const viewMoreBundleFeatureClick = function() {
        let url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        viewMoreBundleFeature(url, productInfoBundle);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((BundleDetailsAccordianUI_module_default()).BundlesDetailsAccordianUI, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collapsible-accordion bundle-accordian-section ".concat(label.toLowerCase()),
            "data-testid": "bundle-product-accordion-".concat(label),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader/* default */.Z, {
                    title: label
                }),
                onTriggerOpening: ()=>handleOpenAccordian(label),
                onTriggerClosing: ()=>handleCloseAccordian(label),
                triggerOpenedClassName: "collapsible__trigger--open",
                open: false,
                openedClassName: "collapsible--open",
                transitionTime: 400,
                tabIndex: "0",
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: data.map((item)=>{
                    const { category , slug , productWebFeatures =[] , productBadgeInfo =[]  } = item || {};
                    const linkUrl = getViewMoreLink(category, slug, item.selectededSku);
                    return (productWebFeatures === null || productWebFeatures === void 0 ? void 0 : productWebFeatures.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 ".concat((BundleDetailsAccordianUI_module_default()).accordianContainer),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "sku-title",
                                children: item.customerFacingSku
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "title",
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "lists",
                                children: item.productWebFeatures.slice(0, 5).map((fl, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: fl
                                    }, "product-key-" + i))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: "link",
                                href: linkUrl,
                                onClick: ()=>viewMoreBundleFeatureClick(linkUrl),
                                children: viewMoreLabel
                            }),
                            productBadgeInfo.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icons",
                                children: productBadgeInfo.map((icon, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: getProductBadgeInfo(icon),
                                        alt: "watersense icon"
                                    }, "image" + i))
                            }) : null
                        ]
                    }, item.selectededSku) : null;
                })
            })
        })
    });
};
/* harmony default export */ var ui_BundleFeaturesUI = (BundleFeaturesUI);

// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
;// CONCATENATED MODULE: ./public/icons/tooltip-bundles.svg
/* harmony default export */ var tooltip_bundles = ({"src":"/_next/static/media/tooltip-bundles.26f52edc.svg","height":15,"width":14});
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/BundleDimensionsUI.jsx










const BundleDimensionsUI = (props)=>{
    const { data =[] , label ="" , config ={} , productInfoBundle ={}  } = props || {};
    const [activeTooltipIdx, setActiveTooltipIdx] = (0,react.useState)(-1);
    const { regexPattern: { map: { productDimensionsRegex =""  } = {}  } = {}  } = config;
    const removeSpecialChars = (str)=>{
        const strValue = String(str || "");
        const regex = new RegExp(productDimensionsRegex);
        return strValue.replace(regex, "");
    };
    const tooltipHover = (index, message)=>{
        setActiveTooltipIdx(index);
        dimensionsTooltipAnalyticsData(label, message, productInfoBundle);
    };
    const handleOpenAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "expand", productInfoBundle);
    };
    const handleCloseAccordian = function() {
        let title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        accordianClickBundleFeature(title.toLowerCase(), "collapse", productInfoBundle);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Accordion_module_default()).accordionWrapper, " ").concat((BundleDetailsAccordianUI_module_default()).BundlesDetailsAccordianUI, " container-fluid"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collapsible-accordion bundle-accordian-section ".concat(label.toLowerCase()),
            "data-testid": "bundle-product-accordion-".concat(label),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapsibleHeader/* default */.Z, {
                    title: label
                }),
                onTriggerOpening: ()=>handleOpenAccordian(label),
                onTriggerClosing: ()=>handleCloseAccordian(label),
                triggerOpenedClassName: "collapsible__trigger--open",
                open: false,
                openedClassName: "collapsible--open",
                transitionTime: 400,
                tabIndex: "0",
                easing: "ease-in-out",
                triggerElementProps: {
                    id: (0,utils/* accordionUniqueId */.M0)("collapsible-trigger", 9999, 1000)
                },
                contentElementId: (0,utils/* accordionUniqueId */.M0)("collapsible-content", 9999, 1000),
                children: data.map((item)=>{
                    const { dimensionData =[]  } = item || {};
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 ".concat((BundleDetailsAccordianUI_module_default()).accordianContainer),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "sku-title",
                                children: item.customerFacingSku
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "title",
                                children: item.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bundle-dimensions",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "container",
                                    children: dimensionData.map((d, index)=>{
                                        var ref;
                                        return d.value ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "label ".concat(index % 2 === 0 ? "highlighted" : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: d.label
                                                        }),
                                                        d.tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "tooltipIcon",
                                                                    src: tooltip_bundles === null || tooltip_bundles === void 0 ? void 0 : tooltip_bundles.src,
                                                                    alt: "Tooltip",
                                                                    onMouseLeave: ()=>{
                                                                        setActiveTooltipIdx(-1);
                                                                    },
                                                                    onMouseOver: ()=>{
                                                                        tooltipHover(String("".concat(d.key, "-").concat(item.sku)), d.tooltip);
                                                                    },
                                                                    onFocus: ()=>{
                                                                        tooltipHover("".concat(d.key, "-").concat(item.sku), d.tooltip);
                                                                    },
                                                                    onBlur: ()=>{
                                                                        setActiveTooltipIdx(-1);
                                                                    }
                                                                }),
                                                                String(activeTooltipIdx) === "".concat(d.key, "-").concat(item.sku) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                                    message: d.tooltip
                                                                }) : null
                                                            ]
                                                        }) : null
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "value ".concat(index % 2 === 0 ? "highlighted" : ""),
                                                    children: "".concat(removeSpecialChars(d.value), " ").concat((ref = d === null || d === void 0 ? void 0 : d.unit) !== null && ref !== void 0 ? ref : "")
                                                })
                                            ]
                                        }, "".concat(d.key, "-").concat(item.sku)) : null;
                                    })
                                })
                            })
                        ]
                    }, item.sku);
                })
            })
        })
    });
};
/* harmony default export */ var ui_BundleDimensionsUI = (BundleDimensionsUI);

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/BundleDetailsAccordian.jsx









const BundleDetailsAccordian = (props)=>{
    const { config ={} , productInfoBundle ={}  } = props || {};
    const { state  } = useStore();
    const { bundleItems =[] , selectedProducts =[] , pdpDetails: { sku =""  } = ""  } = state;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { featuresLabel ="" , dimensionsLabel ="" , specsInstallationLabel =""  } = (0,localization/* getTranslations */.F)(t);
    const [accordianData, setAccordianData] = (0,react.useState)({});
    const { bundleList =[] , dimensionDataList =[] , specFiles =[] , installGuidesFiles =[]  } = accordianData;
    const selectedSkus = selectedProducts.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.sku;
    });
    const selectedSkusString = JSON.stringify(selectedSkus);
    // Filter Dimensions Spec and Install data
    (0,react.useEffect)(()=>{
        const bundleList = [];
        const dimensionDataList = [];
        const specFiles = [];
        const installGuidesFiles = [];
        const getProductDimensionGata = (item)=>{
            const { productDimensionAttributes: ProductDimensionAttributes , productDimensionAttributesValues: ProductDimensionAttributesValues , installGuidesFiles: installGuides = [] , specPDFFileName =[] , selectededSku ="" , customerFacingSku ="" , title =""  } = item;
            const dimensionData = ProductDimensionAttributes.length && ProductDimensionAttributesValues.length ? {
                ProductDimensionAttributes,
                ProductDimensionAttributesValues
            } : {};
            const { dimensions =[]  } = (0,ProductAccordionList_utils/* getDimensionData */.S)(dimensionData);
            if (dimensions.length) {
                dimensionDataList.push({
                    sku: selectededSku,
                    customerFacingSku,
                    name: title,
                    dimensionData: dimensions
                });
            }
            installGuidesFiles.push(...installGuides);
            specFiles.push(...specPDFFileName);
        };
        selectedProducts.forEach((product)=>{
            const { products =[]  } = bundleItems.find((item)=>item.name === product.name) || {};
            products.forEach((item)=>{
                if (item.masterSku === product.masterSku) {
                    item["selectededSku"] = product.sku;
                    item["customerFacingSku"] = product.customerFacingSku;
                    bundleList.push(item);
                    getProductDimensionGata(item);
                }
            });
        });
        setAccordianData({
            bundleList,
            dimensionDataList,
            installGuidesFiles,
            specFiles
        });
    }, [
        selectedSkusString
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            bundleList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BundleFeaturesUI, {
                label: featuresLabel,
                data: bundleList,
                productInfoBundle: productInfoBundle
            }) : null,
            dimensionDataList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BundleDimensionsUI, {
                label: dimensionsLabel,
                data: dimensionDataList,
                config: config,
                productInfoBundle: productInfoBundle
            }) : null,
            specFiles.length || installGuidesFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BundleSpecsInstallationUI, {
                sku: sku,
                label: specsInstallationLabel,
                specFiles: specFiles,
                installGuidesFiles: installGuidesFiles,
                productInfoBundle: productInfoBundle
            }) : null
        ]
    });
};
/* harmony default export */ var MultiFinshProductBundle_BundleDetailsAccordian = (BundleDetailsAccordian);

// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/ProductActionsUI.module.scss
var ProductActionsUI_module = __webpack_require__(34346);
var ProductActionsUI_module_default = /*#__PURE__*/__webpack_require__.n(ProductActionsUI_module);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
;// CONCATENATED MODULE: ./public/icons/alert-small.svg
/* harmony default export */ var alert_small = ({"src":"/_next/static/media/alert-small.36939fa0.svg","height":30,"width":16});
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/ProductActionsUI.jsx







const ProductActionsUI = (props)=>{
    const { quantity =1 , loading =false , handleChange =()=>{} , staticTexts ={} , isAllProductsAvailable =false , handleAddToCart =()=>{}  } = props || {};
    const { outOfStockAlert ="" , addToCartLabel ="" , addToCartNote =""  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ProductActionsUI_module_default()).ProductActionsUIWrapper,
        children: [
            !isAllProductsAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "out-of-stock-alert",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "alert-icon",
                        alt: "alert icon",
                        src: alert_small.src
                    }),
                    outOfStockAlert
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "add-cart-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "quantity-selector-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                            isPDPQuantitySelector: true,
                            doNotRequiredAnalyticsData: true,
                            isAddToCart: true,
                            value: quantity,
                            loading: loading,
                            onChange: handleChange
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "add-to-cart-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            label: addToCartLabel,
                            role: "button",
                            size: "large",
                            type: "primary",
                            flexible: true,
                            disabled: loading || !quantity || parseInt(quantity) < 1 || !isAllProductsAvailable,
                            loading: loading,
                            onClick: debounce_default()(handleAddToCart, 500)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "note",
                children: addToCartNote
            })
        ]
    });
};
/* harmony default export */ var ui_ProductActionsUI = (ProductActionsUI);

// EXTERNAL MODULE: ./components/sharedCart/shareCartHelper.js
var shareCartHelper = __webpack_require__(4364);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ProductActions.jsx











const ProductActions = (props, ref)=>{
    const { productInfoBundle ={}  } = props || {};
    const dispatch = (0,es/* useDispatch */.I0)();
    const { state  } = useStore();
    const { selectedProducts =[] , bundleItems =[] , pdpDetails =[] , projectionData =[]  } = state;
    const { sku: bundleSku  } = pdpDetails || {};
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    const [quantity, setQuantity] = (0,react.useState)(1);
    const [loading, setLoading] = (0,react.useState)(false);
    const handleChange = function() {
        let qty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (qty > 0) {
            setQuantity(qty);
        }
    };
    const onAddToCart = (isFaild)=>{
        if (!isFaild) dispatch((0,genericSlice/* showPreviewCart */.z0)());
        setLoading(false);
    };
    const handleAddToCart = ()=>{
        setLoading(true);
        const bundleAddToCartData = [];
        const updateProductInfoBundle = productInfoBundle.map((item)=>({
                ...item,
                quantity: quantity
            }));
        bundleAddToCartAnalytics(updateProductInfoBundle);
        const selectedSkus = (selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.map((selected)=>selected.sku)) || [];
        bundleAddToCartData.push({
            bundleId: bundleSku,
            selectedSkus: selectedSkus
        });
        const items = getAddToCartItems(selectedProducts, bundleItems, projectionData, quantity, bundleAddToCartData);
        (0,shareCartHelper/* shareaddToCart */.J9)(items, "", onAddToCart);
    };
    const isAllProductsAvailable = checkIsAllProductsAvailable(selectedProducts, projectionData);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "product-actions",
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ProductActionsUI, {
            quantity: quantity,
            loading: loading,
            handleChange: handleChange,
            staticTexts: staticTexts,
            handleAddToCart: handleAddToCart,
            isAllProductsAvailable: isAllProductsAvailable
        })
    });
};
/* harmony default export */ var MultiFinshProductBundle_ProductActions = (/*#__PURE__*/(0,react.forwardRef)(ProductActions));

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/BundleInfoUI.module.scss
var BundleInfoUI_module = __webpack_require__(12886);
var BundleInfoUI_module_default = /*#__PURE__*/__webpack_require__.n(BundleInfoUI_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/BundleInfoUI.jsx



const BundleInfoUI = (props)=>{
    const { pdpDetails ={} , staticTexts ={} , finalProductPrice ="" , isPriceLoading =true , config ={}  } = props || {};
    const { internationalization: { currencySign ="$"  } = {}  } = config;
    const { name ="" , desc ="" , sku =""  } = pdpDetails || {};
    const productName = name || desc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BundleInfoUI_module_default()).BundleInfo,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "title-desc",
                children: productName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "title",
                            children: productName
                        }),
                        name && desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "description",
                            children: desc
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title-desc",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-170"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-170 description"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "skuid",
                children: sku
            }),
            !isPriceLoading && finalProductPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "price",
                "aria-label": "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.currentPriceAriaLabel, " ").concat(currencySign).concat(finalProductPrice),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                    value: finalProductPrice,
                    displayType: "text",
                    thousandSeparator: true,
                    prefix: currencySign,
                    decimalScale: 2,
                    fixedDecimalScale: true
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "shimmer-loading__para shimmer width-170 price-spinner"
            })
        ]
    });
};
/* harmony default export */ var ui_BundleInfoUI = (BundleInfoUI);

// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductDetailView/utils.js
var ProductDetailView_utils = __webpack_require__(21328);
// EXTERNAL MODULE: ./components/core/ColorSwatch/ColorSwatch.jsx
var ColorSwatch = __webpack_require__(32982);
// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/ColorFinishSelectorUI.module.scss
var ColorFinishSelectorUI_module = __webpack_require__(50135);
var ColorFinishSelectorUI_module_default = /*#__PURE__*/__webpack_require__.n(ColorFinishSelectorUI_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/ColorFinishSelectorUI.jsx





const ColorFinishSelectorUI = (props)=>{
    const { staticTexts ={} , config ={} , avaiableColors =[] , swatchName , handleClickSwatch =()=>{}  } = props || {};
    const { colorOrFinish =""  } = staticTexts || {};
    const handleKeyDown = (i, e)=>{
        const { KEYCODE  } = constants["default"];
        const ele = e.target.parentNode.childNodes;
        switch(e.keyCode){
            case KEYCODE.UP:
                if (i > 0) ele[i - 1].focus();
                break;
            case KEYCODE.DOWN:
                if (i < ele.length - 1) ele[i + 1].focus();
                break;
            case KEYCODE.SPACE:
            case KEYCODE.ENTER:
                ele[i].querySelector("input").click();
                break;
            default:
                break;
        }
    };
    const colorsData = (0,ProductDetailView_utils/* getFirstSkuColor */.ku)(avaiableColors);
    const colorsDataInfoFilter = colorsData.filter((colorInfo)=>!colorInfo.notApplicable);
    const colorLength = colorsDataInfoFilter.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ColorFinishSelectorUI_module_default()).ColorFinishSelector,
        children: [
            colorLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-colors",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "select-product",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "1. "
                            }),
                            " ",
                            colorOrFinish
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "selected-color",
                        tabIndex: "0",
                        "aria-roledescription": "Finish Type ".concat(swatchName, " selected"),
                        children: swatchName
                    })
                ]
            }) : null,
            colorLength > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "color-finish-lists",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "finish-type-list",
                    className: "color-swatch-lists",
                    role: "listbox",
                    children: colorsDataInfoFilter.map((item, i)=>{
                        const isChecked = item.label === swatchName;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "radio",
                            tabIndex: 0,
                            "aria-label": item.label,
                            "aria-checked": isChecked,
                            onKeyDown: (e)=>handleKeyDown(i, e),
                            className: isChecked ? "bundle-selected" : "",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorSwatch/* default */.Z, {
                                type: "selector",
                                id: item.id,
                                name: item.name,
                                value: item.value,
                                label: item.label,
                                colorUrl: item.colorUrl,
                                checked: isChecked,
                                onClick: ()=>handleClickSwatch(item.label),
                                initConfig: config
                            }, item.id + i)
                        }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-").concat(i));
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ui_ColorFinishSelectorUI = (ColorFinishSelectorUI);

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/BundleInfo.jsx





const BundleInfo = (props)=>{
    const { bundlePdpData ={}  } = props || {};
    const { pdpDetails ={}  } = bundlePdpData;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "multi-bundle-info",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_BundleInfoUI, {
                ...props,
                pdpDetails: pdpDetails,
                staticTexts: staticTexts
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ColorFinishSelectorUI, {
                ...props,
                staticTexts: staticTexts
            })
        ]
    });
};
/* harmony default export */ var MultiFinshProductBundle_BundleInfo = (BundleInfo);

// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/SelectedProductListUI.module.scss
var SelectedProductListUI_module = __webpack_require__(54847);
var SelectedProductListUI_module_default = /*#__PURE__*/__webpack_require__.n(SelectedProductListUI_module);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/SelectedProductListUI.jsx







const SelectedProductListUI = (props)=>{
    const { productData =[] , noOfChildItems =0 , currency ="" , isOpen =false , handleIsOpen =()=>{} , staticTexts ={} , finalProductPrice =0 , isPriceLoading =true  } = props || {};
    const { colorOrFinish ="" , qty =0 , subTotal ="" , includesItemsQty =()=>{}  } = staticTexts;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SelectedProductListUI_module_default()).BundleProductListSectionWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "title",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            onClick: handleIsOpen,
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: includesItemsQty(noOfChildItems)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "bundle-arrow ".concat(isOpen ? "arrow-up" : "arrow-down"),
                                    src: arrow_up/* default.src */.Z.src,
                                    alt: isOpen ? "Arrow Up" : "Arrow Down"
                                })
                            ]
                        }),
                        !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "subtotal",
                            children: [
                                "".concat(subTotal),
                                " \xa0",
                                !isPriceLoading && finalProductPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                    value: finalProductPrice,
                                    displayType: "text",
                                    thousandSeparator: true,
                                    prefix: currency,
                                    decimalScale: 2,
                                    fixedDecimalScale: true
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "shimmer-loading__para shimmer width-170 price-spinner-subtotal"
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "lists items ".concat(isOpen ? "list-open" : "list-close"),
                    children: productData.map((item)=>{
                        const { image =image_missing/* default */.Z , productName ="" , color ="" , quantity =0 , unitPrice =0 , sku =""  } = item || {};
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "child-items",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            width: 50,
                                            height: 50,
                                            src: image,
                                            alt: sku
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "section",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "title",
                                                children: productName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "attributes",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            colorOrFinish,
                                                            ":",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details",
                                                                children: color
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            qty,
                                                            ":",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "details",
                                                                children: quantity
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                className: "price-group mobile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "price",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: unitPrice,
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currency,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "price-group",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                value: unitPrice,
                                                displayType: "text",
                                                thousandSeparator: true,
                                                prefix: currency,
                                                decimalScale: 2,
                                                fixedDecimalScale: true
                                            })
                                        })
                                    })
                                ]
                            })
                        }, sku);
                    })
                }),
                isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "subtotal",
                    children: [
                        subTotal,
                        "\xa0",
                        !isPriceLoading && finalProductPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                            value: finalProductPrice,
                            displayType: "text",
                            thousandSeparator: true,
                            prefix: currency,
                            decimalScale: 2,
                            fixedDecimalScale: true
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-170 price-spinner-subtotal"
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ui_SelectedProductListUI = (SelectedProductListUI);

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/BundleSelectedProductList.jsx







const BundleSelectedProductList = (props)=>{
    const { config ={} , finalProductPrice =0 , isPriceLoading =true , bundleItems =[] , skusPrice =[] , selectedProducts =[] , productInfoBundle =[]  } = props || {};
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { internationalization: { currencySign ="$"  } = {}  } = config;
    const productData = getSelectedProductData({
        bundleItems,
        selectedProducts,
        skusPrice
    });
    var ref;
    const noOfChildItems = (ref = productData === null || productData === void 0 ? void 0 : productData.length) !== null && ref !== void 0 ? ref : 0;
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    const handleIsOpen = ()=>{
        const accordianAction = isOpen ? "collapse" : "expand";
        selectedProductListAnalytics(productInfoBundle, accordianAction);
        setIsOpen((prevState)=>!prevState);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SelectedProductListUI, {
        productData: productData,
        noOfChildItems: noOfChildItems,
        currency: currencySign,
        staticTexts: staticTexts,
        isOpen: isOpen,
        handleIsOpen: handleIsOpen,
        isPriceLoading: isPriceLoading,
        finalProductPrice: finalProductPrice
    });
};
/* harmony default export */ var MultiFinshProductBundle_BundleSelectedProductList = (BundleSelectedProductList);

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./components/Shared/ProductSocialShare/v1/socialShare.module.scss
var socialShare_module = __webpack_require__(76118);
var socialShare_module_default = /*#__PURE__*/__webpack_require__.n(socialShare_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/BundleProductSocialShare.jsx







const BundleProductSocialShare = (props)=>{
    const { id ="" , url ="" , componentProp: { assetUrl ="" , url: compUrl = "" , showModal: componentPropShowModal = false  } = {} , disableInstagram =false , showModal =false , onClose =()=>{} , mailBody ="" , mailSubject ="" , config ={} , productInfoBundle =[]  } = props || {};
    const [sites, setSites] = (0,react.useState)([]);
    const [link, setLink] = (0,react.useState)("");
    const { t  } = (0,esm/* useTranslation */.$G)();
    const emailBtnRef = (0,react.useRef)(null);
    const copyBtnRef = (0,react.useRef)(null);
    const shareBoxRef = (0,react.useRef)(null);
    const { general ={} , general: { hostUrl ="" , siteName ="" , socialShareCopyIconPath , socialShareEmailIconPath =""  } = {} , socialMediaConfig: socialMediaConfigs = {}  } = config || {};
    // get component social share link url
    /**
   *
   * @return  {string} the the url
   */ const getLink = ()=>{
        const isFullUrl = /^https?:\/\//i;
        const origin = window.location.origin;
        if (url && isFullUrl.test(url)) {
            return url;
        }
        if (url) {
            return "".concat(origin).concat(url);
        } else if (assetUrl && compUrl) {
            // teaser video component link all cases
            if (!isFullUrl.test(compUrl)) {
                const newcompUrl = (0,helper/* getShortenedUrlwithGeneral */.vu1)(compUrl, general);
                return "".concat(origin).concat(newcompUrl);
            } else {
                return compUrl;
            }
        } else if (assetUrl) {
            return assetUrl;
        } else {
            return (0,helper/* sanitizeUrl */.Nmg)(window.location.href);
        }
    };
    (0,react.useEffect)(()=>{
        const link = getLink();
        setLink(link);
    }, []);
    const i18n = {
        email: t("kf.share.label.email"),
        emailSubject: t("kf.share.label.emailSubject"),
        copyLink: t("kf.share.label.copyLink"),
        copyLinkIndication: t("kf.share.label.copyLinkIndication"),
        yourSharedCartNumber: t("kf.share.label.yourSharedCartNumber", {
            cartNumber: props.sharedCartNum
        }),
        linksCTA: (siteKey)=>t("kf.pdp.label.aria.socialLinksCTA", {
                siteName,
                siteKey
            }),
        openNewTabText: t("kf.share.label.openNewTabText")
    };
    const [copyIcon, setCopyIcon] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        if (socialMediaConfigs.myArrayList) {
            let siteList = [];
            const origin = window.location.origin;
            socialMediaConfigs === null || socialMediaConfigs === void 0 ? void 0 : socialMediaConfigs.myArrayList.forEach((socialMediaConfig)=>{
                if (!isEmpty_default()(socialMediaConfig.map) && socialMediaConfig.map.name) {
                    var _name, _iconPath;
                    const site = {
                        key: (_name = socialMediaConfig.map.name) !== null && _name !== void 0 ? _name : "",
                        icon: (_iconPath = socialMediaConfig.map.iconPath) !== null && _iconPath !== void 0 ? _iconPath : ""
                    };
                    var _redirectUrl;
                    const url = (_redirectUrl = socialMediaConfig.map.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "";
                    if (socialMediaConfig.map.name.toLowerCase().includes("twitter")) {
                        siteList.push({
                            ...site,
                            url: encodeURI(url + link + "&text=".concat(document.title))
                        });
                    } else if (socialMediaConfig.map.name.toLowerCase().includes("pinterest")) {
                        if (props.asset) siteList.push({
                            ...site,
                            url: url + "".concat(origin, "&media=").concat(props.asset.url, "&is_video=").concat(props.asset.isVideo, "$description=").concat(props.asset.description)
                        });
                    } else {
                        siteList.push({
                            ...site,
                            url: url + link
                        });
                    }
                }
            });
            if (disableInstagram && siteList.length) {
                siteList = siteList.filter((site)=>!site.key.toLowerCase().includes("instagram"));
            }
            setSites(siteList);
        }
    }, [
        socialMediaConfigs
    ]);
    const emailLink = (e)=>{
        e.stopPropagation();
        bundleBreadCrumbEmailAndCopyLinkAnalytics({
            productInfo: productInfoBundle
        });
    };
    /**
   *
   * @param {string} e
   */ function socialLinks(e) {
        if (e.target && e.target.hostname && e.target.href) {
            const target = e.target;
            bundleBreadSocialShareAnalytics({
                productInfo: productInfoBundle || [],
                link: e.target.href || "",
                hostname: e.target.hostname || ""
            });
            const nodeUrl = target.hostname.replace(/(^www\.)/, "");
            if (!window.excludUrl || window.excludUrl && !window.excludUrl.includes(nodeUrl)) {
                e.stopPropagation();
                e.preventDefault();
                if (window.handleShowModal) window.handleShowModal(target.href, target);
            } else if (target.href) {
                window.open(target.href);
            }
        }
    }
    (0,react.useEffect)(()=>{
        var ref, ref1, ref2;
        copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.addEventListener("click", copyLink, false);
        shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.addEventListener("click", shareBox, false);
        emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.addEventListener("click", emailLink, false);
        if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
            var ref3;
            (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                link === null || link === void 0 ? void 0 : link.addEventListener("click", socialLinks, false);
            });
        }
        return ()=>{
            var // garbage collection
            ref, ref1, ref2;
            copyBtnRef === null || copyBtnRef === void 0 ? void 0 : (ref = copyBtnRef.current) === null || ref === void 0 ? void 0 : ref.removeEventListener("click", copyLink, false);
            shareBoxRef === null || shareBoxRef === void 0 ? void 0 : (ref1 = shareBoxRef.current) === null || ref1 === void 0 ? void 0 : ref1.removeEventListener("click", shareBox, false);
            emailBtnRef === null || emailBtnRef === void 0 ? void 0 : (ref2 = emailBtnRef.current) === null || ref2 === void 0 ? void 0 : ref2.removeEventListener("click", emailLink, false);
            if (shareBoxRef === null || shareBoxRef === void 0 ? void 0 : shareBoxRef.current) {
                var ref3;
                (ref3 = Array.from(shareBoxRef.current.getElementsByClassName("kf-social-links"))) === null || ref3 === void 0 ? void 0 : ref3.forEach((link)=>{
                    link === null || link === void 0 ? void 0 : link.removeEventListener("click", socialLinks, false);
                });
            }
        };
    }, [
        sites,
        props.showModal
    ]);
    const shareRef = (0,react.useRef)(null);
    const handleClick = (e)=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument.getElementById(props.id) : document.getElementById(props.id);
        if (props.showModal && !(selELement === null || selELement === void 0 ? void 0 : selELement.contains(e.target))) props.onClose();
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && window.shareSrcElement !== null && window.shareSrcElement !== undefined && !shareRef.current.contains(e.target)) {
            const shareElems = [
                ...document.getElementsByClassName("share-cmp")
            ];
            shareElems.forEach((el)=>{
                el.style.display = "none";
            });
            window.shareSrcElement = null;
        }
        return true;
    };
    const handleClose = (e)=>{
        if (e.keyCode === 27) {
            props.onClose();
            props.shareBtn.current.focus();
        }
    };
    (0,react.useEffect)(()=>{
        var ref;
        const selELement = props.iframeId ? document.getElementById(props.iframeId).contentDocument : document;
        if (props.showModal) {
            selELement.addEventListener("click", handleClick);
            selELement.addEventListener("keydown", handleClose);
            return ()=>{
                selELement.removeEventListener("click", handleClick);
                selELement.removeEventListener("keydown", handleClose);
            };
        }
        if (((ref = props.componentProp) === null || ref === void 0 ? void 0 : ref.showModal) && props.showModal) {
            document.addEventListener("click", handleClick);
        }
    }, [
        props.showModal
    ]);
    const copyLink = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        bundleBreadCrumbEmailAndCopyLinkAnalytics({
            productInfo: productInfoBundle,
            link
        });
        navigator.clipboard.writeText(link);
        setCopyIcon(true);
        setTimeout(()=>{
            setCopyIcon(false);
        }, 3000);
    };
    const shareBox = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const { linksCTA =()=>{} , openNewTabText ="" , copyLinkIndication ="" , copyLink: staticTextcopyLink = "" , email =""  } = i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (socialShare_module_default()).socialShareWrapper,
        children: (showModal !== null && showModal !== void 0 ? showModal : componentPropShowModal) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "social-share",
            id: id,
            ref: shareRef,
            "data-testid": id,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "social-share__box",
                ref: shareBoxRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "social-share__sites",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            role: "list",
                            children: sites.map((param, i)=>{
                                let { url ="" , key ="" , icon =""  } = param;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        id: "kf-social-links-".concat(i),
                                        rel: "noreferrer",
                                        href: url,
                                        className: "kf-social-links",
                                        "aria-label": "".concat(linksCTA(key), " ").concat(openNewTabText),
                                        target: "_blank",
                                        "data-link-type": "social media",
                                        role: "link",
                                        tabIndex: "0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            "aria-hidden": "true",
                                            src: "".concat(hostUrl).concat(icon),
                                            alt: key,
                                            className: "social-share__".concat(key),
                                            role: "presentation"
                                        })
                                    })
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "social-share__actions",
                        role: "list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    tabIndex: "0",
                                    role: "button",
                                    ref: copyBtnRef,
                                    className: "social-share__cta",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "social-share__copy-link-icon",
                                            "aria-hidden": true,
                                            src: "".concat(hostUrl).concat(socialShareCopyIconPath),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        copyIcon ? copyLinkIndication : staticTextcopyLink
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                role: "listitem",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "social-share__cta social-share__email",
                                    "aria-label": "".concat(email, " ").concat(openNewTabText),
                                    onKeyDown: ()=>onClose(),
                                    ref: emailBtnRef,
                                    href: (0,helper/* sanitizeUrl */.Nmg)("mailto:?body=".concat(mailBody + link).concat(mailSubject ? "&subject=" + mailSubject : "")),
                                    target: "_blank",
                                    rel: "noreferrer",
                                    role: "link",
                                    tabIndex: "0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(hostUrl).concat(socialShareEmailIconPath),
                                            role: "presentation",
                                            alt: ""
                                        }),
                                        email
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        }) : null
    });
};
/* harmony default export */ var MultiFinshProductBundle_BundleProductSocialShare = (BundleProductSocialShare);

;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/BundleProductBreadcrumb.jsx







const BundleProductBreadcrumb = (props)=>{
    const { staticTexts: { ariaLabel: { breadcrumb ="" , page ="" , print ="" , share =""  } = {} , home ="" , serviceParts ="" , priceFootnoteTitle ="" , priceFootnote ="" , colorFootnoteTitle ="" , colorFootnote =""  } , productCategory ="" , homePagePath ="" , productData ={} , swatchUrl ="" , imagesData =[] , width =0 , presetConfigObject ={} , productInfoBundle =[]  } = props || {};
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const shareBtn = (0,react.useRef)(null);
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { general: { plpPagePath: plpPagePathGeneral = "" , servicePartsLandingPath =""  } = {} , plpServletPath =[]  } = globalConfig || {};
    const plpPagePath = (0,helper/* getShortenedUrlPath */.mXk)(plpPagePathGeneral !== null && plpPagePathGeneral !== void 0 ? plpPagePathGeneral : "/");
    const serviceLandingPath = (0,helper/* getShortenedUrlPath */.mXk)(servicePartsLandingPath !== null && servicePartsLandingPath !== void 0 ? servicePartsLandingPath : "/");
    const getPlpCategoryUrl = ()=>{
        const path = plpServletPath === null || plpServletPath === void 0 ? void 0 : plpServletPath.find((i)=>i.categories.includes(productCategory));
        let plpUrl;
        if (productCategory) {
            if (path) {
                plpUrl = "".concat(path.url, ".html");
            } else if (productCategory === "Service Parts") {
                plpUrl = "".concat(serviceLandingPath, ".html");
            } else {
                plpUrl = "".concat(plpPagePath, "/").concat(productCategory.replace(/ +/g, "-").toLowerCase(), ".html");
            }
        } else {
            plpUrl = "".concat(serviceLandingPath, ".html");
        }
        return (0,helper/* getShortenedUrlPath */.mXk)(plpUrl);
    };
    // Hide social share options when user clicks outide the options
    (0,react.useEffect)(()=>{
        window.addEventListener("click", handleClickOutside);
        return ()=>window.removeEventListener("click", handleClickOutside);
    }, []);
    const handleClickOutside = (e)=>{
        const { target  } = e;
        if (!shareBtn.current.contains(target)) {
            setShowSocialLink(false);
        }
    };
    const handleShareClick = ()=>{
        bundleBreadCrumbShareAnalytics(productInfoBundle);
        setShowSocialLink((prevProp)=>!prevProp);
    };
    const handleBreadCrumbAnalytics = (home, homePagePath)=>{
        const categoryPath = getPlpCategoryUrl();
        const pagePath = homePagePath || categoryPath;
        bundleBreadCrumbAnalytics({
            internalLinkName: home,
            link: pagePath,
            productInfoBundle
        });
    };
    const printPDP = ()=>{
        const printNoteLen = document.getElementsByClassName("product-detail-page__print-note").length;
        if (printNoteLen === 0) {
            const printNote = "<div class='product-detail-page__print-note'><div class='container'><div class='row'><div class='col-12'><h6>".concat(priceFootnoteTitle, "</h6><p>").concat(priceFootnote, "</p><h6>").concat(colorFootnoteTitle, "</h6> <p>").concat(colorFootnote, "</p></div></div></div></div>");
            const printNoteDiv = document.createElement("div");
            printNoteDiv.innerHTML = printNote;
            document.body.appendChild(printNoteDiv);
        }
        bundleBreadCrumbPrintAnalytics(productInfoBundle);
        setTimeout(()=>{
            window.print();
        }, 900);
    };
    if (productData) {
        var ref;
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-section kf-react-plp-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "product-detail-page__breadcrumb",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        "aria-label": breadcrumb,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                            role: "list",
                            "data-testid": "bcm-list",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    role: "listitem",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": "".concat(home, " ").concat(page),
                                            className: "product-detail-page__breadcrumb-link",
                                            href: homePagePath,
                                            onClick: ()=>handleBreadCrumbAnalytics(home, homePagePath),
                                            children: " ".concat(home)
                                        }),
                                        " / "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": productCategory ? "".concat(productCategory, " ").concat(page) : "".concat(serviceParts, " ").concat(page),
                                        className: "product-detail-page__breadcrumb-link",
                                        href: getPlpCategoryUrl(),
                                        onClick: ()=>{
                                            handleBreadCrumbAnalytics("".concat(home, " > ").concat(productCategory));
                                        },
                                        children: productCategory ? productCategory : serviceParts
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-detail-page__print-share-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "list",
                            className: "print-and-share",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        tabIndex: "0",
                                        "aria-label": print,
                                        onClick: ()=>printPDP(),
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/icons/print.svg",
                                                alt: "",
                                                role: "presentation",
                                                width: "17",
                                                height: "17"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "listitem",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        tabIndex: "0",
                                        "aria-label": share,
                                        className: "share-button",
                                        ref: shareBtn,
                                        onClick: handleShareClick,
                                        role: "button",
                                        "aria-haspopup": true,
                                        "aria-expanded": showSocialLink,
                                        "aria-controls": "print-and-share",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/icons/share.svg",
                                            alt: "",
                                            role: "presentation",
                                            width: "17",
                                            height: "17"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_BundleProductSocialShare, {
                            disableInstagram: true,
                            showModal: showSocialLink,
                            shareBtn: shareBtn,
                            id: "print-and-share",
                            productInfoBundle: productInfoBundle,
                            onClose: ()=>{
                                return shareBtn === null || shareBtn === void 0 ? void 0 : shareBtn.current.focus();
                            },
                            config: globalConfig,
                            asset: {
                                description: (ref1 = productData === null || productData === void 0 ? void 0 : productData.ProductDescriptionProductShort_s) !== null && ref1 !== void 0 ? ref1 : "",
                                url: (0,helper/* appendPresetToUrl */.QCk)(swatchUrl, (ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.assetId, width, presetConfigObject, true)
                            }
                        })
                    ]
                })
            ]
        });
    }
};
/* harmony default export */ var MultiFinshProductBundle_BundleProductBreadcrumb = (BundleProductBreadcrumb);

// EXTERNAL MODULE: ./i18n/usePdpi18n.js
var usePdpi18n = __webpack_require__(58886);
// EXTERNAL MODULE: ./components/MultiFinshProductBundle/styles/MultiFinshProductBundleUI.module.scss
var MultiFinshProductBundleUI_module = __webpack_require__(82522);
var MultiFinshProductBundleUI_module_default = /*#__PURE__*/__webpack_require__.n(MultiFinshProductBundleUI_module);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/ui/MultiFinshProductBundleUI.jsx
















const MultiFinshProductBundleUI = (props)=>{
    const { bundlePdpData ={} , isPriceLoading =true , finalProductPrice =0 , skusPrice =[] , selectedProducts =[] , quickViewAuthData ={} , authoredData ={} , config ={} , productInfoBundle =[] , avaiableColors =[] , swatchName ="" , handleClickSwatch =()=>{} , addCartRef =null , allImages =[] , layeredIMageURL ="" , setTriggerAnalyticsOnProductClick =()=>{}  } = props || {};
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const configData = !(0,utils/* isObjectEmpty */.nK)(config) ? config : globalConfig;
    const { pdpDetails: { name ="" , productLocalCategory =""  } , bundleItems =[]  } = bundlePdpData;
    const { presetConfigs ="{}"  } = authoredData;
    const { general ={}  } = configData;
    const { homepageUrl ="" , newBadgeName ="" , saleBadgeName ="" , exclusiveBadgeName ="" , discontinuedBadgeName ="" , swatchUrl =""  } = general;
    const badgeText = {
        new: newBadgeName,
        onSale: saleBadgeName,
        exclusive: exclusiveBadgeName,
        discontinued: discontinuedBadgeName
    };
    const staticTexts = (0,usePdpi18n/* default */.Z)(authoredData, badgeText, name);
    const homePagePath = (0,helper/* getShortenedUrlwithGeneral */.vu1)(homepageUrl, general);
    const [width] = (0,useWindowResize/* default */.Z)();
    const presetConfigObject = JSON.parse(presetConfigs);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (MultiFinshProductBundleUI_module_default()).MultiFinshProductBundleUI,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_BundleProductBreadcrumb, {
                staticTexts: staticTexts,
                productCategory: productLocalCategory,
                name: name,
                homePagePath: homePagePath,
                swatchUrl: swatchUrl,
                width: width,
                presetConfigObject: presetConfigObject,
                isBundleProduct: true,
                productInfoBundle: productInfoBundle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "product-details",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-side-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "sticky-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_ImageGalleryUI, {
                                config: configData,
                                data: allImages,
                                layerImageData: {
                                    layerUrl: layeredIMageURL
                                },
                                productInfoBundle: productInfoBundle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "right-side-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_BundleInfo, {
                                isPriceLoading: isPriceLoading,
                                bundlePdpData: bundlePdpData,
                                finalProductPrice: finalProductPrice,
                                config: configData,
                                avaiableColors: avaiableColors,
                                swatchName: swatchName,
                                handleClickSwatch: handleClickSwatch
                            }),
                            bundleItems.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_ProductOptionSelector, {
                                        data: item,
                                        index: index,
                                        quickViewAuthData: quickViewAuthData,
                                        authoredData: authoredData,
                                        config: configData,
                                        swatchName: swatchName,
                                        productInfoBundle: productInfoBundle,
                                        skusPrice: skusPrice,
                                        finalProductPrice: finalProductPrice,
                                        selectedProducts: selectedProducts,
                                        setTriggerAnalyticsOnProductClick: setTriggerAnalyticsOnProductClick
                                    })
                                }, item.name);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_BundleSelectedProductList, {
                                bundleItems: bundleItems,
                                skusPrice: skusPrice,
                                selectedProducts: selectedProducts,
                                presetConfigObject: presetConfigObject,
                                config: configData,
                                isPriceLoading: isPriceLoading,
                                finalProductPrice: finalProductPrice,
                                productInfoBundle: productInfoBundle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_ProductActions, {
                                productInfoBundle: productInfoBundle,
                                ref: addCartRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_BundleDetailsAccordian, {
                                config: configData,
                                productInfoBundle: productInfoBundle
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MultiFinshProductBundleUI = (MultiFinshProductBundleUI);

// EXTERNAL MODULE: ./services/productServices.js
var productServices = __webpack_require__(35285);
;// CONCATENATED MODULE: ./components/MultiFinshProductBundle/MultiFinshProductBundle.jsx



















const MultiFinshProductBundle = (props)=>{
    var ref;
    const { config  } = props || {};
    const { state , dispatch  } = useStore();
    const dispatchReduxAction = (0,es/* useDispatch */.I0)();
    const { general: { siteName ="kohler"  } = {} , internationalization: { currencyCode ="USD" , currencySign ="$"  } = {}  } = config;
    const { swatchName: changedSwatchName = "" , bundleItems =[] , selectedProducts: selectedProductItems = [] , pdpDetails: { productLocalCategory: category = "" , sku =""  } = {} , inventory =[] , projectionData , imageGallery: { bundleIMageURL ="" , bundleListImages =[]  } = {}  } = state;
    const [skusPrice, setSkusPrice] = (0,react.useState)([]);
    const [finalProductPrice, setFinalProductPrice] = (0,react.useState)(0);
    const [isPriceLoading, setIsPriceLoading] = (0,react.useState)(true);
    const [showStickyHeader, setShowStickyHeader] = (0,react.useState)(false);
    const addCartRef = (0,react.useRef)(null);
    const [width] = (0,useWindowResize/* default */.Z)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticTexts = (0,localization/* getTranslations */.F)(t);
    const [productInfoBundle, setProductInfoBundle] = (0,react.useState)([]);
    const [triggerAnalyticsOnColorChange, setTriggerAnalyticsOnColorChange] = (0,react.useState)(false);
    const [triggerAnalyticsOnProductClick, setTriggerAnalyticsOnProductClick] = (0,react.useState)(null);
    const skuPriceString = JSON.stringify(skusPrice);
    const productInfoBundleString = JSON.stringify(productInfoBundle);
    const commonColorsDefault = getCommonColorDetails({
        bundleItems
    });
    const initSelectedProducts = bundleItems.map((bundle, index)=>{
        const { name: defaultSwatchName = ""  } = commonColorsDefault.at(0) || {};
        const { products =[] , name =""  } = bundle || {};
        const { masterSku , sku , colorDetails =[]  } = products.at(0);
        const { customerFacingSku =""  } = colorDetails.find((item)=>item.sku === masterSku) || {};
        return {
            id: index,
            masterSku,
            name,
            sku,
            swatchName: defaultSwatchName,
            customerFacingSku
        };
    });
    const selectedProducts = selectedProductItems.length > 0 ? selectedProductItems : initSelectedProducts;
    const selectedSkus = selectedProducts.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.sku;
    });
    const selectedMasterSkus = selectedProducts.map((item)=>{
        return item === null || item === void 0 ? void 0 : item.masterSku;
    });
    const commonColors = getCommonColorDetails({
        bundleItems,
        selectedMasterSkus
    });
    const { name: swatchNameInit = ""  } = commonColors.at(0) || {};
    const swatchName = changedSwatchName || swatchNameInit;
    const inventoryString = JSON.stringify(inventory);
    const selectedProductsString = JSON.stringify(selectedProducts);
    const selectedSkusString = JSON.stringify(selectedSkus);
    const getAllBundleProductsVariantQuantity = async (allBundleProductsSku)=>{
        dispatch(setInventoryStatusAction(false));
        const { inventories =[]  } = await (0,productServices/* getProductInventory */.o)(allBundleProductsSku.join(","));
        dispatch(setInventoryDataAction(inventories));
        dispatch(setInventoryStatusAction(true));
    };
    const getAllProductsPrice = async (skus)=>{
        setIsPriceLoading(true);
        const productLists = await (0,productServices/* getProductsBySku */.uX)(skus);
        dispatch(setProjectionDataAction(productLists));
        setIsPriceLoading(false);
    };
    const getAvailableColors = (data)=>{
        const { swatchName , commonColors  } = data || {};
        return commonColors.map((color, index)=>{
            const { name ="" , swatch =""  } = color;
            return {
                id: swatch,
                name: "product-color",
                value: swatch,
                label: name,
                notApplicable: swatch.toLowerCase() === constants.SWATCH_NA.toLowerCase(),
                colorUrl: constants["default"].COLOR_FILE_URL + swatch,
                checked: swatchName === name ? true : index === 0
            };
        });
    };
    const avaiableColors = getAvailableColors({
        commonColors,
        swatchName
    });
    const bundleStickyHeaderProps = getStickyHeaderProps(state, staticTexts, avaiableColors, swatchName);
    const { allImages , imageURL  } = processImageData(bundleListImages, selectedSkus, bundleIMageURL);
    const stickyImageURL = imageURL.includes("<<IMAGE") ? allImages === null || allImages === void 0 ? void 0 : (ref = allImages[0]) === null || ref === void 0 ? void 0 : ref.url : imageURL;
    const callOnColorChange = (color)=>{
        const allskus = bundleItems === null || bundleItems === void 0 ? void 0 : bundleItems.map((bundle)=>{
            var ref;
            return bundle === null || bundle === void 0 ? void 0 : (ref = bundle.products) === null || ref === void 0 ? void 0 : ref.map((product)=>{
                const { colorDetails , imageDetails  } = product || {};
                const { sku: productSku  } = getSelectedColorImage({
                    colorDetails,
                    imageDetails,
                    swatchName: color
                });
                return productSku;
            });
        });
        const allBundleProductsSku = (allskus === null || allskus === void 0 ? void 0 : allskus.flat()) || [];
        // Call the API to get the inventory and price data based on the selected swatch name
        if (allBundleProductsSku.length > 0) {
            getAllProductsPrice(allBundleProductsSku);
            getAllBundleProductsVariantQuantity(allBundleProductsSku);
        }
    };
    const handleClickSwatch = (swatch)=>{
        dispatch(setSwatchColorAction(swatch));
        callOnColorChange(swatch);
        const productsData = [];
        selectedProducts.forEach((item, index)=>{
            const { masterSku , name =""  } = item || {};
            const { products =[]  } = bundleItems.find((bundle)=>bundle.name === item.name) || {};
            const { colorDetails =[]  } = products.find((product)=>product.masterSku === masterSku) || {};
            const { sku: variantSku = "" , customerFacingSku =""  } = colorDetails.find((variant)=>variant.name === swatch) || {};
            productsData.push({
                id: index,
                name,
                masterSku,
                sku: variantSku,
                customerFacingSku,
                swatchName: swatch
            });
        });
        dispatch(setInitSelectedProductsAction(productsData));
        setTriggerAnalyticsOnColorChange(true);
    };
    (0,react.useEffect)(()=>{
        if (swatchNameInit) {
            callOnColorChange(swatchNameInit);
            const initSelectedProducts = bundleItems.map((bundle, index)=>{
                const { products =[] , name =""  } = bundle || {};
                const { masterSku , sku , colorDetails =[]  } = products.at(0);
                const { customerFacingSku =""  } = colorDetails.find((item)=>item.sku === masterSku) || {};
                const isInventory = isAvailableInventory({
                    inventory,
                    sku: masterSku
                });
                return {
                    masterSku,
                    index,
                    name,
                    sku,
                    swatchName: swatchNameInit,
                    isInventory,
                    customerFacingSku
                };
            });
            dispatch(setInitSelectedProductsAction(initSelectedProducts));
        }
    }, [
        swatchNameInit
    ]);
    // productInfo for bundle
    (0,react.useEffect)(()=>{
        const productInfodata = getProductInfo({
            data: state,
            skusPrice: skusPrice,
            siteName: siteName,
            swatchName: swatchName
        });
        setProductInfoBundle(productInfodata);
    }, [
        skuPriceString
    ]);
    // Set the productInfo in the global window object and dispatch it to the store
    // This is used to add the product info in the PDP initial datalayer events
    (0,react.useEffect)(()=>{
        if (triggerAnalyticsOnColorChange) {
            colorSelectorAnalytics(productInfoBundle);
            setTriggerAnalyticsOnColorChange(false);
        }
        if (triggerAnalyticsOnProductClick) {
            let { sku: clickedSku = "" , optionCategory =""  } = triggerAnalyticsOnProductClick || {};
            clickedSku = "K-".concat(clickedSku);
            const clickedProductInfo = productInfoBundle === null || productInfoBundle === void 0 ? void 0 : productInfoBundle.find((product)=>{
                return (product === null || product === void 0 ? void 0 : product.productID) === clickedSku;
            });
            productOptionSelectorAnalytics(clickedProductInfo, optionCategory);
            setTriggerAnalyticsOnProductClick(null);
        }
        let cmpShowAnlyticsTimer = null;
        if (!(0,helper/* isShowAnalyticsEventLoaded */.xJ2)() && (productInfoBundle === null || productInfoBundle === void 0 ? void 0 : productInfoBundle.length)) {
            window.productInfo = JSON.stringify(productInfoBundle);
            window.pageObj.productInfo = [
                ...productInfoBundle
            ];
            dispatch((0,genericSlice/* setPageObject */.FE)(true));
            const dataLayer = window.adobeDataLayer || [];
            const loadTargetEvent = dataLayer.find((item)=>{
                return (item === null || item === void 0 ? void 0 : item.event) === "cmp:loadTarget";
            });
            if (loadTargetEvent) {
                loadTargetEvent.page = {
                    ...loadTargetEvent.page || window.pageObj,
                    productInfo: [
                        ...productInfoBundle
                    ]
                };
            }
            // To trigger the cmp:show event
            cmpShowAnlyticsTimer = setInterval(()=>{
                if (window.datalayerTopLoaded && !(0,helper/* isShowAnalyticsEventLoaded */.xJ2)()) {
                    loadCmpShowEvent({
                        productInfoBundle,
                        siteName,
                        category,
                        sku,
                        cmpShowAnlyticsTimer
                    });
                } else if ((0,helper/* isShowAnalyticsEventLoaded */.xJ2)()) {
                    clearInterval(cmpShowAnlyticsTimer);
                }
            }, 100);
        }
        return ()=>{
            if (cmpShowAnlyticsTimer) {
                clearInterval(cmpShowAnlyticsTimer);
            }
            delete window.productInfo;
        };
    }, [
        productInfoBundleString
    ]);
    const addCartCallback = (entries)=>{
        var ref;
        const [entry] = entries;
        const currentValue = !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && (entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.y) < 0;
        setShowStickyHeader(currentValue);
    };
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    };
    (0,react.useEffect)(()=>{
        if (width > 1023) {
            const observer = new IntersectionObserver(addCartCallback, options);
            if (addCartRef === null || addCartRef === void 0 ? void 0 : addCartRef.current) observer.observe(addCartRef.current);
            return ()=>{
                if (addCartRef === null || addCartRef === void 0 ? void 0 : addCartRef.current) observer.observe(addCartRef.current);
            };
        }
    }, [
        addCartRef,
        options
    ]);
    const handleStickyNavAddToCart = function() {
        let cb = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ()=>{};
        bundleAddToCartFromStickyAnalytics(productInfoBundle);
        const items = getAddToCartItems(selectedProducts, bundleItems, projectionData, 1);
        (0,shareCartHelper/* shareaddToCart */.J9)(items, "", (isFaild)=>{
            !isFaild && dispatchReduxAction((0,genericSlice/* showPreviewCart */.z0)());
            cb();
        });
    };
    const projectionDataString = JSON.stringify(projectionData);
    (0,react.useEffect)(()=>{
        const persona = (0,helper/* getUserPersona */.shu)();
        const productsPrice = getSelectedProductPrices({
            productLists: projectionData,
            skus: selectedSkus,
            currencyCode,
            persona
        });
        const totalPrice = productsPrice.reduce((sum, num)=>sum + (Number(num.discountPrice) || Number(num.priceProduct) || 0), 0);
        setSkusPrice(productsPrice);
        setFinalProductPrice(totalPrice);
    }, [
        projectionDataString,
        selectedSkusString
    ]);
    (0,react.useEffect)(()=>{
        const allBundleProducts = selectedProducts.map((item)=>{
            const isInventory = isAvailableInventory({
                inventory: inventory,
                sku: item.sku
            });
            return {
                ...item,
                isInventory
            };
        });
        dispatch(setInitSelectedProductsAction(allBundleProducts));
    }, [
        selectedProductsString,
        inventoryString
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyHead/* default */.Z, {
                showStickyHeader: showStickyHeader,
                price: finalProductPrice,
                currencySign: currencySign,
                isDynamicBundle: true,
                onAddToCart: handleStickyNavAddToCart,
                stickyHeaderImageURL: stickyImageURL,
                ...bundleStickyHeaderProps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MultiFinshProductBundleUI, {
                ...props,
                isPriceLoading: isPriceLoading,
                finalProductPrice: finalProductPrice,
                skusPrice: skusPrice,
                selectedProducts: selectedProducts,
                productInfoBundle: productInfoBundle,
                avaiableColors: avaiableColors,
                swatchName: swatchName,
                addCartRef: addCartRef,
                allImages: allImages,
                layeredIMageURL: imageURL,
                handleClickSwatch: handleClickSwatch,
                setTriggerAnalyticsOnProductClick: setTriggerAnalyticsOnProductClick
            })
        ]
    });
};
/* harmony default export */ var MultiFinshProductBundle_MultiFinshProductBundle = (MultiFinshProductBundle);

// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/core/Head/NextHead.jsx
var NextHead = __webpack_require__(20812);
// EXTERNAL MODULE: ./components/ProductDetail/v3/ProductLandingTeasers/ProductExf.jsx
var ProductExf = __webpack_require__(97463);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
;// CONCATENATED MODULE: ./components/BundlePdpPage.jsx





















const FallBackUI = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 42346)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42346)
            ]
    }
});

const BundlePdpPage = (props)=>{
    const { slug ="" , pageModelData , authoredData , pdpData ={} , header , footer , errorsData , fullUrl , config ={} , rawAnalyticsData ="" , seoProperties: { email ="" , phoneNum =""  } = {}  } = props || {};
    if (!(0,utils/* isObjectEmpty */.nK)(errorsData)) {
        console.error("getServerSideProps Error", errorsData);
    }
    (0,usePageAuth/* default */.Z)();
    const quickViewAuthData = (0,helper/* getQuickViewAuth */.sKe)(footer);
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const { pageIsInteractive  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { isTeaserLoaded  } = (0,es/* useSelector */.v9)(pdpSlice/* selectPdpState */.BY);
    const dispatch = (0,es/* useDispatch */.I0)();
    const { internationalization: { language ="" , country =""  } = {} , general: { priceSpiderKey ="" , siteName =""  } = {}  } = config;
    const { globalScript ="" , footerScript ="" , templateName ="" , language: metaLanguage = ""  } = pageModelData;
    const bundlePdpData = getBundlePdpData(pdpData);
    const { pdpDetails: { name: metaTitles = "" , desc: metaDescriptions = "" , sku ="" , productLocalCategory =""  } = {} , imageGallery: { bundleIMageURL ="" , bundleListImages =[]  } = {}  } = bundlePdpData;
    const scrollToTop = ()=>{
        window.scrollTo(0, 0);
    };
    (0,react.useEffect)(()=>{
        scrollToTop();
        window.needPdpdata = {
            productSubCatergory: productLocalCategory === null || productLocalCategory === void 0 ? void 0 : productLocalCategory.toLowerCase(),
            skuID: sku,
            siteName: siteName.toLowerCase()
        };
    }, [
        pdpData
    ]);
    (0,react.useEffect)(()=>{
        if (pdpData && accessToken && pageIsInteractive && !isTeaserLoaded) {
            (0,productDetailsHelper/* getTeaserFragments */.lX)(pageModelData, pdpData);
        }
    }, [
        accessToken,
        pdpData,
        pageIsInteractive,
        isTeaserLoaded
    ]);
    (0,react.useEffect)(()=>{
        const filterData = (0,helper/* filterBackEndJson */.LjD)(pageModelData);
        const tempData = (0,utils/* recursiveDataFunction */.Qe)(filterData, constants.COMPONENT_TYPES.PRODUCT_DETAILS).at(0);
        dispatch((0,genericSlice/* setAuthorData */.su)(tempData));
    }, [
        pageModelData
    ]);
    // To set initial datalayer page properties
    const analyticsData = (0,helper/* updateAnalyticPageUrl */.CQb)(rawAnalyticsData, fullUrl);
    (0,react.useEffect)(()=>{
        if (analyticsData) (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    if (errorsData.pdpData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FallBackUI, {});
    }
    // Set the page title,description and image, specific to bundles
    const pageTitle = "".concat(metaTitles, " | ").concat(sku, " | ").concat(siteName.toUpperCase());
    const pageDescription = "Shop the ".concat(metaTitles, ", including the ").concat(metaDescriptions, ".");
    const selectedSkus = [];
    for (const value of bundleListImages){
        selectedSkus.push(value[0].sku);
    }
    const { imageURL  } = processImageData(bundleListImages, selectedSkus, bundleIMageURL);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* default */.Z, {
                psKey: priceSpiderKey,
                psCountry: country,
                psLanguage: language,
                fullUrl: fullUrl,
                metaLanguage: metaLanguage,
                pdpData: pdpData,
                skuId: sku,
                siteName: siteName,
                isBundleProduct: true,
                persona: (0,helper/* getUserPersona */.shu)(),
                config: config
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "afterInteractive",
                src: constants.BV_SCRIPT_URL,
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "zoomdatapdp",
                src: "".concat(v2_constants/* SCENE7_JS_URL */.e5, "ZoomViewer.js")
            }, "zoomdatapdp"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                type: "text/javascript",
                src: "".concat(v2_constants/* SCENE7_JS_URL */.e5, "SpinViewer.js")
            }),
            !(0,utils/* isObjectEmpty */.nK)(header) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                header: header,
                title: pageTitle,
                description: pageDescription,
                templateName: templateName,
                globalScripting: globalScript,
                isPdp: true,
                fullUrl: fullUrl,
                siteName: siteName,
                email: email,
                phone: phoneNum,
                imageUrl: imageURL
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreProvider, {
                value: bundlePdpData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiFinshProductBundle_MultiFinshProductBundle, {
                    bundlePdpData: bundlePdpData,
                    slug: slug,
                    skuId: sku,
                    quickViewAuthData: quickViewAuthData,
                    authoredData: authoredData,
                    config: config
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductExf/* default */.Z, {
                data: pageModelData
            }),
            !(0,utils/* isObjectEmpty */.nK)(footer) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer,
                footerScripting: footerScript
            }) : null
        ]
    });
};
/* harmony default export */ var components_BundlePdpPage = (BundlePdpPage);


/***/ }),

/***/ 60303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        viewDetails: t("kf.pdp.bundles.viewDetails"),
        includedItemsLabel: t("kf.pdp.bundles.includedItems"),
        colorOrFinish: t("kf.pdp.label.colorOrFinish"),
        qty: t("kf.checkout.label.qtyLabel"),
        subTotal: t("kf.pdp.label.subTotal"),
        subTotalItems: (number)=>t("kf.pdp.bundles.subTotalItems", {
                number
            }),
        saveOnBundle: (number)=>t("kf.pdp.bundles.saveOnBundle", {
                number
            }),
        includedItemsQty: (number)=>t("kf.pdp.bundles.includedItemsQty", {
                number
            }),
        includesItemsQty: (number)=>t("kf.pdp.bundles.includesItemsQty", {
                number
            }),
        featuresLabel: t("kf.pdp.label.features"),
        specsInstallationLabel: t("kf.pdp.bundles.specsInstallation"),
        dimensionsLabel: t("kf.pdp.bundles.dimensions"),
        viewMoreLabel: t("kf.pdp.label.viewMore"),
        downloadAllSpecSheetsLabel: t("kf.pdp.bundles.downloadAllSpecSheets"),
        downloadAllInstallGuidesLabel: t("kf.pdp.bundles.downloadAllInstallGuides"),
        cannotShipLabel: t("kf.cart.label.cannotShip"),
        includedPdpItemsLabel: t("kf.pdp.bundles.includedPdpItemsLabel"),
        outOfStockLabel: t("kf.cart.label.outOfStock"),
        outOfStockText: t("kf.pdp.bundles.outOfStock"),
        outOfStockAlert: t("kf.pdp.bundles.alert.outOfStock"),
        quickViewLabel: t("kf.button.quickView"),
        addToCartLabel: t("kf.global.label.addCart"),
        addToCartNote: t("kf.pdp.bundles.addToCartNote"),
        currentPriceAriaLabel: t("kf.pdp.label.currentPrice")
    };
};


/***/ }),

/***/ 67166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 69503:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundlesDetailsAccordianUI":"BundleDetailsAccordianUI_BundlesDetailsAccordianUI__rbVOf","accordianContainer":"BundleDetailsAccordianUI_accordianContainer__NrOnG"};

/***/ }),

/***/ 12886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundleInfo":"BundleInfoUI_BundleInfo__di6Kp"};

/***/ }),

/***/ 50135:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ColorFinishSelector":"ColorFinishSelectorUI_ColorFinishSelector__Xsf57"};

/***/ }),

/***/ 53646:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ImageGalleryUI":"ImageGalleryUI_ImageGalleryUI__oQ0zk","cssAnimation":"ImageGalleryUI_cssAnimation__qNhVT"};

/***/ }),

/***/ 82522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MultiFinshProductBundleUI":"MultiFinshProductBundleUI_MultiFinshProductBundleUI__SU6zo"};

/***/ }),

/***/ 34346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductActionsUIWrapper":"ProductActionsUI_ProductActionsUIWrapper__poMX_"};

/***/ }),

/***/ 63811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductOptionSelectorUIWrapper":"ProductOptionSelectorUI_ProductOptionSelectorUIWrapper__cKaWp"};

/***/ }),

/***/ 54847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BundleProductListSectionWrapper":"SelectedProductListUI_BundleProductListSectionWrapper__2x1cQ","fadeInOpacity":"SelectedProductListUI_fadeInOpacity__kFaY8"};

/***/ })

}]);